<template>
    <Card :bordered="false" dis-hover class="importNoticeCommon">
        <div align="right">
            <!--撤回-->
            <Button type="primary" style="margin-right:10px;" :loading="loading" v-if="isCustoms && isSubmitted && needWithdraw" @click="importReject">{{ $t('importNoticeCommon.t150') }}</Button>
            <!--同步保税属性-->
            <Button type="primary" style="margin-right:10px;" @click="refreshBondedTradeType" :loading="loading" v-if="syncBsShow">{{ $t('importNoticeCommon.t141') }}</Button>
            <Button type="primary" style="margin-right:10px;" @click="handlSave" :loading="loading" :disabled="rowsTableData.length === 0 || onlyRead">{{this.$t('common.saveBtn')}}</Button>
            <Button type="primary" style="margin-right:10px;" @click="goBack" :loading="loading">{{$t('common.back')}}</Button>
            <Button type="primary" @click="handleSubmit" :loading="loading" :disabled="this.formItem.imptStatus === 'SUBMITTED' || rowsTableData.length === 0 || onlyRead">{{$t('common.commit')}}</Button>
        </div>
        <Tabs type="card">
          <!-- 单据信息 -->
          <TabPane :label="$t('importNoticeCommon.t24')">
              <Form :model="formItem" :rules="formItemRules" :label-width="110" ref="formItemRef">
                <Row type="flex" style="flex-wrap: nowrap;">
                    <Col span="24">
                        <Row>
                            <Col span="8">
                                <!-- 库存组织 -->
                                <FormItem :label="$t('importNoticeCommon.t2')" prop="orgCode" :rules="{required: true, message: $t('importNoticeCommon.t3'), trigger: 'change'}">
                                    <Select v-model="formItem.orgCode"
                                            placeholder="" size="small"
                                            :filterable="true"
                                            :disabled= !isNew
                                            :clearable="true" transfer @on-change="onChangeOrgCode">
                                        <Option v-for="(item, index) in orgList" :value="item.value" :key="index">{{item.label}}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col span="8">
                                <!-- 供应商编码 只能输入数字和英文 -->
                                <FormItem :label="$t('importNoticeCommon.t25')" prop="vendorCode" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                    <Input v-model.trim="formItem.vendorCode" size="small" :disabled="true"></Input>
                                </FormItem>
                            </Col>
                            <Col span="8">
                                <!-- 供应商名称 -->
                                <FormItem :label="$t('importNoticeCommon.t26')" prop="vendorName">
                                    <Input v-model.trim="formItem.vendorName" size="small" :disabled="true"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="8">
                                <!-- 通知书号 -->
                                <FormItem :label="$t('importNoticeCommon.t5')" prop="imptNumber" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                    <Input v-model.trim="formItem.imptNumber" size="small" :disabled="true"></Input>
                                </FormItem>
                            </Col>
                            <Col span="8">
                                <!-- 创建日期 -->
                                <FormItem :label="$t('importNoticeCommon.t27')" prop="creationDate">
                                    <DatePicker type="date" v-model="formItem.creationDate" format="yyyy-MM-dd" placement="bottom" style="width:100%" :option="options" :disabled="true" transfer size="small"></DatePicker>
                                </FormItem>
                            </Col>
                            <Col span="8">
                                <!-- 单据状态 不能为空 -->
                                <FormItem :label="$t('importNoticeCommon.t7')" prop="imptStatus" :rules="{required: false, message: $t('importNoticeCommon.t3'), trigger: 'change'}">
                                    <Select v-model="formItem.imptStatus"
                                            placeholder="" size="small"
                                            :filterable="true"
                                            :disabled="true"
                                            :clearable="true" transfer>
                                        <Option v-for="(item, index) in cuxInStatusList" :value="item.value" :key="index">{{item.label}}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 贸易方式 -->
                            <!-- <Col span="8">
                                <FormItem :label="$t('importNoticeCommon.t46')" prop="tradingMode" :rules="{required: true, message: $t('importNoticeCommon.t3'), trigger: 'change'}">
                                    <Select v-model="formItem.tradingMode"
                                            placeholder="" size="small"
                                            :filterable="true"
                                            :disabled="!isNew"
                                            :clearable="true" transfer>
                                        <Option v-for="(item, index) in cuxTradeModeList" :value="item.value" :key="index">{{item.label}}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Col> -->
                            <Col span="16">
                                <!-- 备注 -->
                                <FormItem :label="$t('importNoticeCommon.t19')" prop="remarks">
                                    <Input v-model="formItem.remarks" type="textarea" size="small" :rows="1" :disabled="onlyRead"/>
                                </FormItem>
                            </Col>
                            <Col span="8">
                                <!-- 预计发船日期 -->
                                <FormItem :label="$t('importNoticeCommon.t84')" prop="etd">
                                    <DatePicker type="date" v-model="formItem.etd" format="yyyy-MM-dd" placement="bottom" style="width:100%" :option="options" :disabled="onlyRead" transfer @on-change="onChangeEtd" size="small"></DatePicker>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start">
                            <Col span="8">
                                <!-- 预计到港日期 -->
                                <FormItem :label="$t('importNoticeCommon.t85')" prop="eta">
                                    <DatePicker type="date" v-model="formItem.eta" format="yyyy-MM-dd" placement="bottom" style="width:100%" :option="options" :disabled="onlyRead" transfer @on-change="onChangeEta" size="small"></DatePicker>
                                </FormItem>
                            </Col>
                            <!-- 包装种类 -->
                            <!-- <Col span="8">
                                <FormItem :label="$t('importNoticeCommon.t86')" prop="typeOfPackage" :rules="{required: true, message: $t('importNoticeCommon.t3'), trigger: 'change'}">
                                    <Select v-model="formItem.typeOfPackage"
                                            placeholder="" size="small"
                                            :filterable="true"
                                            :disabled="onlyRead"
                                            :clearable="true" transfer>
                                        <Option v-for="(item, index) in intTypeOfPakageList" :value="item.value" :key="index">{{item.label}}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Col> -->
                            <Col span="8">
                                <!-- 提运单号 -->
                                <FormItem :label="$t('importNoticeCommon.t87')" prop="billNo" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                    <Input v-model.trim="formItem.billNo" size="small" :disabled="true"></Input>
                                </FormItem>
                            </Col>
                            <Col span="8">
                                <!-- 进口日期 -->
                                <FormItem :label="$t('importNoticeCommon.t88')" prop="iEDate">
                                    <DatePicker type="date" v-model="formItem.iEDate" format="yyyy-MM-dd" placement="bottom" style="width:100%" :option="options" :disabled="true" transfer size="small"></DatePicker>
                                </FormItem>
                            </Col>
                            <Col span="8" v-if="onlyRead">
                                <!-- 报关单号 -->
                                <FormItem :label="$t('importNoticeCommon.t11')" prop="customsNumber">
                                    <Input v-model="formItem.customsNumber" type="textarea" size="small" :rows="1" :disabled="onlyRead"/>
                                </FormItem>
                            </Col>
                            <Col span="8" v-if="!isNew">
                                <!-- IEMS错误信息 -->
                                <FormItem :label="$t('importNoticeCommon.t109')" prop="synMessage">
                                    <Input v-model="formItem.synMessage" type="textarea" size="small" :title="formItem.synMessage" :rows="1" :disabled="true"/>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row v-if="!onlyRead">
                            <Col span="24">
                                <!-- 通知书附件 附件不能为空 -->
                            <FormItem :label="$t('importNoticeCommon.t28')" prop="annexId" :rules="[{required: true, message: $t('importNoticeCommon.t29'), trigger: 'blur'}]">
                                <Upload
                                        action="/gscint/supplierfile/uploadFile" 
                                        :format="fileTypeList"
                                        ref="uploadFileRef"
                                        :multiple="true"
                                        :show-upload-list="false"
                                        :before-upload="beforeUpload"
                                        :on-progress="uploadProgress"
                                        :on-success="uploadSuccess" :on-error="failUpload" 
                                        :on-format-error="onFormatError"
                                        :on-form-change="fileUpload" 
                                        :on-remove="removeFile"
                                        :disabled="false">
                                    <!-- 选择上传文件 -->
                                    <Button type="ghost" icon="ios-cloud-upload-outline" :loading="uploadLoading">{{$t('importNoticeCommon.t30')}}</Button>
                                </Upload>
                                <p v-for="(item, i) in this.uploadFiles" :key="i" style="diaplay:inline-block;margin-bottom:5px;">
                                    <a href="javascript:void(0)" style="margin-right:2px;" @click.prevent="downloadFile2(item.annexId)">
                                        {{item.annexName}}
                                        <!-- 下载 -->
                                        <Button size="small" type="primary" style="margin-left:15px;">{{$t('common.download')}}</Button>
                                    </a>
                                    <!-- 删除 -->
                                    <Button size="small" type="error" @click="deleteFile(item.annexId)">{{$t('common.delBtn')}}</Button>
                                </p>
                                <!-- 只能上传 xls, xlsx, doc, docx, jpeg, jpg, png, gif, pdf, txt, xml, rar, zip, 7z 格式文件，文件大小不能超过 60M -->
                                <span>{{$t('importNoticeCommon.t31')}}</span>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row v-else>
                            <Col span="24">
                                <!-- 通知书附件 附件不能为空 -->
                                <Collapse :value="['1','2']" :simple="true" style="background-color: #ffffff;">
                                <Panel name="1">
                                    {{$t('importNoticeCommon.t28')}}
                                    <div slot="content">
                                        <FormItem :label="$t('importNoticeCommon.t28')" prop="annexId" :rules="[{required: true, message: $t('importNoticeCommon.t29'), trigger: 'blur'}]">
                                            <Upload
                                                    action="/gscint/supplierfile/uploadFile" 
                                                    :format="fileTypeList"
                                                    ref="uploadFileRef"
                                                    :multiple="true"
                                                    :show-upload-list="false"
                                                    :before-upload="beforeUpload"
                                                    :on-progress="uploadProgress"
                                                    :on-success="uploadSuccess" :on-error="failUpload" 
                                                    :on-format-error="onFormatError"
                                                    :on-form-change="fileUpload" 
                                                    :on-remove="removeFile"
                                                    :disabled="false">
                                                <!-- 选择上传文件 -->
                                                <Button type="ghost" icon="ios-cloud-upload-outline" :loading="uploadLoading" :disabled="readDisabled">{{$t('importNoticeCommon.t30')}}</Button>
                                            </Upload>
                                            <p v-for="(item, i) in this.uploadFiles" :key="i" style="diaplay:inline-block;margin-bottom:5px;">
                                                <a href="javascript:void(0)" style="margin-right:2px;" @click.prevent="downloadFile2(item.annexId)">
                                                    {{item.annexName}}
                                                    <!-- 下载 -->
                                                    <Button size="small" type="primary" style="margin-left:15px;">{{$t('common.download')}}</Button>
                                                </a>
                                                <!-- 删除 -->
                                                <Button v-show="!readDisabled" size="small" type="error" @click="deleteFile(item.annexId)">{{$t('common.delBtn')}}</Button>
                                            </p>
                                            <!-- 只能上传 xls, xlsx, doc, docx, jpeg, jpg, png, gif, pdf, txt, xml, rar, zip, 7z 格式文件，文件大小不能超过 60M -->
                                            <span v-show="!readDisabled">{{$t('importNoticeCommon.t31')}}</span>
                                        </FormItem>
                                    </div>
                                </Panel>
                                <Panel name="2" style="background-color: #ffffff;">
                                    {{$t('importNoticeCommon.t32')}}
                                    <div slot="content" style="margin-left: 110px;">
                                        <p v-for="(item, i) in this.customsFiles" :key="i" style="diaplay:inline-block;margin-bottom:5px;">
                                            <a href="javascript:void(0)" style="margin-right:2px;" @click.prevent="downloadCustomFile(item.annexUrl)">
                                                {{item.annexName}}
                                                <!-- 下载 -->
                                                <Button size="small" type="primary" style="margin-left:15px;" :disabled="!item.annexUrl">{{$t('common.download')}}</Button>
                                            </a>
                                        </p>
                                    </div>
                                </Panel>
                                </Collapse>
                            </Col>
                        </Row>
                    </Col>
                    </Row>
              </Form>
          </TabPane>
        </Tabs>
        <div>
            <Form>
                <Row :gutter="0">
                <Col span="24">
                    <!-- 添加  按发票创建、按采购订单创建、拆分品牌 -->
                    <Button v-if="!onlyRead" type="primary" class="each-btn" @click="handleAdd('invoice')" :loading="loading">{{$t('importNoticeCommon.t110')}}</Button>
                    <Button v-if="!onlyRead" type="primary" class="each-btn" @click="handleAdd('po')" :loading="loading">{{$t('importNoticeCommon.t111')}}</Button>
                    <Button v-if="!onlyRead" type="primary" class="each-btn" :disabled="rowsTableData.length === 0" @click="splitBrandModal.show = true" :loading="loading">{{$t('importNoticeCommon.t120')}}</Button>
                    <!-- 导出 -->
                    <Button v-if="headerId" type="primary" class="each-btn" @click="handleExport" :loading="loading">{{$t('common.export')}}</Button>
                    <Button type="primary" class="each-btn" :disabled="selection.length === 0" :loading="loading" @click="deleteInBatchesWarn">{{ $t('importNoticeCommon.t133') }}</Button>

                    <template v-if="isCustoms && isSubmitted">
                        <!--一键报关-->
                        <Button type="primary" class="each-btn" @click="customsNumberModal.show = true">{{ $t('importNoticeCommon.t146') }}</Button>
                        <!--批量导入报关单号-->
                        <Button type="primary" class="each-btn" @click="importCustomsNumberModal.show = true">{{ $t('importNoticeCommon.t147') }}</Button>
                        <!--部分提交报关单号-->
                        <Button :disabled="selection.length === 0" type="primary" class="each-btn" @click="batchSetImptStatusDeclare('')">{{ $t('importNoticeCommon.t148') }}</Button>
                        <!--整单报关-->
                        <Button type="primary" class="each-btn" :loading="customsNumberModal.loading" @click="batchSetImptStatusDeclare('ALL')">{{ $t('importNoticeCommon.t149') }}</Button>
                    </template>

                    <set-table class="each-btn" :columns="rowsColumns" columnsKey="line" @setTableUpdate="setTableUpdate"></set-table> <!--自定义列顺序-->
                    
                    <template>
                        <span class="qty-total">{{ $t('importNoticeCommon.t159') }}：{{ lineQtyTotal }}</span> <!--成交数量汇总-->
                        <span class="qty-total">{{ $t('importNoticeCommon.t160') }}：{{ lineWeightTotal }}</span> <!--总净重汇总-->
                    </template>
                </Col>
                </Row>
            </Form>
        </div>
        <div class="pagination">
            <query ref="mainLineQuery"
                   :formData="mainLineQuery.formData"
                   @onSubmit="onMianLineSearch">
            </query>
            <Table v-if="!block.modal" size="small" 
                   thDrag :columns="rowsColumns" 
                   :data="rowsTableData" 
                   :loading="loading" 
                   height="400" 
                   stripe 
                   highlight-row 
                   border
                   @on-selection-change="onSelect"
                   ref="table">
            </Table>
            <m-pagination v-if="settings.needPager"
                        :showElevator="settings.showElevator"
                        :showSizer="settings.showSizer"
                        :currentPage="settings.currentPage"
                        :pageSize="settings.pageSize"
                        :total="settings.pageTotal"
                        :pageSizeOpts="settings.pageSizeOpts"
                        @on-page-size-change="onPageSizeChange"
                        @on-current-page-change="onPageChange"
            ></m-pagination>
        </div>
        
        <!-- 进口通知书明细添加 -->
        <Modal :title="$t('importNoticeCommon.t34')" v-model="block.modal" :width="1200" :mask-closable="false">
            <m-assembly-table ref='pageForm'
                            v-if="block.modal"
                            :label-width="90" 
                            :height="450"
                            :formData="createType === 'po' ? block.formData : block.formData2"
                            :columns="createType === 'po' ? blockColumnsByPoFilter : blockColumnsFilter"
                            :data='block.tableData'
                            :loading='block.loading'
                            :currentPage='block.settings.currentPage'
                            :pageSize='block.settings.pageSize'
                            :total='block.settings.total'
                            :settings='block.settings'
                            :rowClassName="modalRowClassName"
                            @onSubmit='onSubmit'
                            thDrag
                            hideTable
            >
            </m-assembly-table>
            <Row :gutter="0">
                <Col span="24">
                    <!--跨页全选-->
                    <span style="margin-left:20px;">{{$t('importNoticeCommon.t134')}}：{{ this.block.selection.length }}</span>
                    <!-- 导出(导入模板) -->
                    <Button v-if="createType === 'po'" type="primary" style="margin-left:8px;" @click="exportAndImportTemplate" :loading="loading">{{$t('common.export') + '(' + $t('importNoticeCommon.t99') + ')'}}</Button>
                    <Button v-else type="primary" style="margin-left:8px;" @click="exportAndImportTemplate" :loading="loading">{{$t('common.export') + '(' + $t('importNoticeCommon.t99') + ')'}}</Button>
                    <!-- 导入 -->
                    <!-- <set-table v-if="!isPoType" style="margin-left:8px;" :columns="block.columns.columns" columnsKey="byInvoice" @setTableUpdate="setTableByInvoiceUpdate"></set-table>
                    <set-table v-else style="margin-left:8px;" :columns="block.columnsByPo.columns" columnsKey="byPo" :filterColumns="byPoFilterColumns" @setTableUpdate="setTableByPoUpdate"></set-table> -->
                    <Button type="primary" style="margin-left:8px;" @click="uploadModal=true;" :loading="loading" :disabled="block.tableData.length === 0 || importLock">{{$t('importNoticeCommon.t100')}}</Button>
                    <span class="qty-total">{{ $t('importNoticeCommon.t159') }}：{{ !isPoType ? transQtyTotalByInvoice : dealQtyTotalByPo }}</span> <!--成交数量汇总-->
                    <span class="qty-total">{{ $t('importNoticeCommon.t160') }}：{{ !isPoType ? weightTotalByInvoice : weightTotalByPo }}</span> <!--总净重汇总-->
                </Col>
            </Row>
            <ag-grid
                style="margin-top:20px;"
                ref="gridRef"
                height="595"
                :isCard="false"
                :columnsForIview="createType === 'po' ? blockColumnsByPoFilter : blockColumnsFilter"
                :loading="block.loading"
                :rowData="block.tableData"
                rowSelection='multiple'
                isNeedScrollBar
                :isRowSelectable="isRowSelectable"
                :getRowId="getRowId"
                :rowClassName="modalRowClassName"
                @selection-change="modalOnSelect"
                @onFirstDataRendered="onFirstDataRendered"
                @onRowDataUpdated="onRowDataUpdated"
            >
            </ag-grid>
            <div slot="footer">
                <!-- 确定 -->
                <Button type="primary" :loading="block.loading" :disabled="block.selection.length === 0" @click="handleDetailSure">{{$t('importNoticeCommon.t35')}}</Button>
                <!-- 取消 -->
                <Button type="default" style="margin-left:10px;" @click="blockModalCancel">{{$t('importNoticeCommon.t36')}}</Button>
            </div>
        </Modal>

        <!-- 导入 -->
        <Modal v-model="uploadModal" :width="520" :mask-closable="false" @on-cancel="uploadCancel">
            <h3 slot="header" class="clearfix">
                <!-- 导入窗口 -->
               <span class="pull-left" style="line-height: 45px;font-size: 16px;">{{$t('importNoticeCommon.t100')}}</span>
               <div class="step-header">
                    <div class="step-bar">
                      <div class="step-bar-active" id="step-bar-active"></div>
                    </div>
                    <ul>
                      <li class="active"><span></span>
                        <!-- 数据导入 -->
                        <p>{{$t('importNoticeCommon.t100')}}</p></li>
                      <li v-if="current1 > 0" class="active"><span></span>
                        <!-- 结果确认 -->
                        <p>{{$t('importNoticeCommon.t105')}}</p></li>
                      <li v-else><span></span>
                        <!-- 结果确认 -->
                        <p>{{$t('importNoticeCommon.t105')}}</p></li>
                    </ul>
                </div>
            </h3>
            <div v-if="current1 === 0" class="step-container">
                <Upload ref="upload1" class="text-center"
                    :format="['xls', 'xlsx']"
                    :data="uploadData"
                    :before-upload="importBeforeUpload"
                    :on-progress="uploadProgress2"
                    :on-success="uploadSuccess2"
                    :on-error="uploadError2"
                    :on-format-error="onFormatError2"
                    :action="uploadFileUrl">
                    <Button type="ghost" icon="ios-cloud-upload-outline" :loading="this.uploadFileLoading">{{$t('importNoticeCommon.t104')}}</Button>
                </Upload>
            </div>
            <div v-else-if="current1 === 1" class="step-container">
                <div v-html="excelImportTips"></div>
            </div>
            <div slot="footer">
                <!-- 确定 -->
                <m-button v-if="current1 === 1" type="primary" @click="uploadComplete">{{$t('importNoticeCommon.t35')}}</m-button>
            </div>
        </Modal>
        <!-- 导入end -->
        
        <!--发票号选择-->
        <Modal v-model="invoiceNoModal.show"
               :title="$t('importNoticeCommon.t44')"
               :width="300"
        >   
            <template v-if="insideVendor">
                {{ $t('common.searchBtn') }}： <Input style="width:225px;" size="small" v-model="invoiceKeyWord" @on-change="invoiceFilter"></Input>
            </template>
            <template v-else>
                <Input style="width:200px;" size="small" :maxlength="32" v-model="invoiceKeyWord"></Input>
                <Button style="margin-left:10px;" size="small" type="primary" @click="invoiceOnClick({invoiceNo: invoiceKeyWord})">{{ $t('importNoticeCommon.t35') }}</Button>
            </template>
            
            <Table v-if="invoiceNoModal.show && insideVendor"
                   border
                   style="margin-top:10px;"
                   :height="300" 
                   :loading="invoiceNoModal.loading"
                   :columns="invoiceNoModal.columns" 
                   :data="invoiceNoModal.data"
                   @on-row-click="invoiceOnClick"
                   >
            </Table>
            <div slot="footer"></div>
        </Modal>
        
        <!-- 品牌拆分 -->
        <Modal v-model="splitBrandModal.show"
               :width="1200"
               :title="$t('importNoticeCommon.t120')"
               :mask-closable="false"
        >
            <m-assembly-table ref='pageForm2'
                class="import-notice-split-brand-tab"
                v-if="splitBrandModal.show"
                :label-width="90" 
                :height="450"
                :formData="splitBrandModal.formData"
                :columns='splitBrandModal.columns'
                :data='splitBrandModalFilterData'
                :loading='splitBrandModal.loading'
                :currentPage='splitBrandModal.settings.currentPage'
                :pageSize='splitBrandModal.settings.pageSize'
                :total='splitBrandModal.settings.pageTotal'
                :settings='splitBrandModal.settings'
                :tableButtons="splitBrandModal.tableButtons"
                :row-class-name="rowClassName"
                @onSubmit='splitBrandOnSubmit'
                @onSelect="splitBrandOnSelect"
                @onSelectCancel="splitBrandOnCancel"
                @onSelectionChange='splitBrandOnSelectionChange'
                @onPageSizeChange='splitBrandOnOnPageSizeChange'
                @onCurrentPageChange='splitBrandOnPageChange'
                thDrag
            >
            <span slot="buttonLeft">
                <Checkbox v-model="splitBrandModal.selectAllFlag" @on-change="splitselectAllOnChange($event, true)"></Checkbox> <b>{{$t('importNoticeCommon.t135')}}</b><span style="margin:0 20px;">{{$t('importNoticeCommon.t134')}}：{{ this.splitBrandModal.selection.length }}</span>
            </span>
            </m-assembly-table>
            <div slot="footer"></div>
        </Modal>

        <!--品牌拆分导入-->
        <Modal v-model="splitBrandModal.import.show"
               :width="300"
               :mask-closable="false"
               :title="$t('importNoticeCommon.t100')">
            <Upload ref="upload2"
                :format="['xls', 'xlsx']"
                :show-upload-list="false"
                :data="splitBrandModal.import.data"
                :before-upload="splitBrandBeforeUpload"
                :on-success="splitBrandOnSuccess"
                :on-error="splitBrandOnError"
                :on-format-error="splitBrandOnFormatError"
                :action="splitBrandModal.import.url">
                <Button type="ghost" icon="ios-cloud-upload-outline" :loading="splitBrandModal.import.loading">{{$t('importNoticeCommon.t104')}}</Button>
            </Upload>
            <div slot="footer"></div>
        </Modal>

        <!--维护报关单号-->
        <Modal v-model="customsNumberModal.show"
               :width="300"
               :mask-closable="false"
               :title="$t('importNoticeCommon.t11')">
            <Input v-model="customsNumberModal.customsNumber" size="small"></Input>
            <div slot="footer">
                <Button type="primary" style="margin-right:10px;" :disabled="!customsNumberModal.customsNumber" :loading="customsNumberModal.loading" @click="batchSetCustomerNumber">{{$t('importNoticeCommon.t35')}}</Button>
                <Button type="ghost" :loading="customsNumberModal.loading" @click="customsNumberModal.show = false">{{$t('importNoticeCommon.t36')}}</Button>
            </div>
        </Modal>

        <!--批量导入报关单号-->
        <Modal v-model="importCustomsNumberModal.show"
               :width="300"
               :mask-closable="false"
               :title="$t('importNoticeCommon.t147')">
            <Upload ref="upload3"
                :format="['xls', 'xlsx']"
                :show-upload-list="false"
                :data="importCustomsNumberModal.data"
                :before-upload="customsNumberBeforeUpload"
                :on-success="customsNumberOnSuccess"
                :on-error="customsNumberOnError"
                :on-format-error="customsNumberOnFormatError"
                :action="importCustomsNumberModal.url">
                <Button type="ghost" icon="ios-cloud-upload-outline" :loading="importCustomsNumberModal.loading">{{$t('importNoticeCommon.t104')}}</Button>
            </Upload>

            <a style="display:inline-block;margin-top:10px;" @click="handleExport">{{$t('common.download') + '(' + $t('importNoticeCommon.t99') + ')'}}</a>
            <div slot="footer"></div>
        </Modal>
    </Card>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import mPagination from '@/components/awesome/page/pagination/main';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import query from '@/components/awesome/page/query/index.js';
import { deliveryTotalCount, deepCopy } from '@/utils/tool';
import AgGrid from "@/components/ag-grid/index.vue";
export default {
    props: {
        onlyRead: {
            type: Boolean,
            default: false
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        isNew: {
            type: Boolean,
            default: false
        }
    },
    components: {
        mPagination,
        mAssemblyTable,
        query,
        AgGrid,
    },
    computed: {
        uploadFileUrl () {
            return this.createType === 'po' ? '/gscint/imptNotyExcel/importTempData' : '/gscint/excel/loadExcelData';
        },
        uploadData () {
            let data = '';
            if (this.createType === 'po') {
                data = '';
            } else {
                let columns = [
                    {
                        key: this.isCn ? '序号(勿动)' : 'number(fixed)',
                        value: 'index',
                    }
                ];
                const titles = {
                    brand: {
                        cn: '* 品牌',
                        en: '* Brand',
                    },
                    origin: {
                        cn: '* 原产地',
                        en: '* Origin',
                    },
                    itemNetWeight: {
                        cn: '* 总净重(KG)',
                        en: '* Total net weight(KG)',
                    },
                    supplierInvoiceItemNumber: {
                        cn: '发票项号',
                        en: 'Invoice item number',
                    },
                    supplierInvoiceDate: {
                        cn: '* 发票日期',
                        en: '* Supplier Invoice Date',
                    },
                    grossWeight: {
                        cn: '毛重',
                        en: 'Gross weight',
                    },
                };
                this.block.columns.columns.forEach((item) => {
                    if (item.title) {
                        /* 只导入brand、origin、itemNetWeight、supplierInvoiceItemNumber、supplierInvoiceDate 字段  */
                        if (['brand', 'origin', 'itemNetWeight', 'supplierInvoiceItemNumber', 'supplierInvoiceDate', 'grossWeight'].includes(item.key)) {
                            columns.push({
                                key: titles[item.key][this.isCn ? 'cn' : 'en'],
                                value: item.key,
                            });
                        }
                    }
                });
                data = {
                    keyValue: JSON.stringify(columns)
                }
            }
            return data;
        },
        /* 是否po类型单据 */
        isPoType () {
            return this.createType === 'po';
        },
        /* 是否内部供应商 */
        insideVendor () {
            return this.invoiceNoModal.data.length > 0;
        },
        blockColumnsFilter() {
            const { columns } = this.block.columns;
            /* 非po类型需要过滤部分字段 */
            // return {
            //     columns: !this.isPoType ? columns : columns.filter((item) => !['closedCode', 'peripheralStatus', 'peripheralMessage', 'errorMessage', 'errorSolution', 'omsBrand', 'omsOrigin', 'canCreateNum', 'dealQuantityCopy'].includes(item.key)),
            // };
            return !this.isPoType ? columns : columns.filter((item) => !['closedCode', 'peripheralStatus', 'peripheralMessage', 'errorMessage', 'errorSolution', 'omsBrand', 'omsOrigin', 'canCreateNum', 'dealQuantityCopy', 'grossWeight', 'platform'].includes(item.key));
        },
        blockColumnsByPoFilter() {
            // return {
            //     columns: this.block.columnsByPo.columns.filter((item) => !['closedCode', 'peripheralStatus', 'peripheralMessage', 'errorMessage', 'errorSolution', 'omsBrand', 'omsOrigin', 'canCreateNum', 'dealQuantityCopy'].includes(item.key)),
            // };
            return this.block.columnsByPo.columns.filter((item) => !['convertItemCode', 'closedCode', 'peripheralStatus', 'peripheralMessage', 'errorMessage', 'errorSolution', 'omsBrand', 'omsOrigin', 'canCreateNum', 'dealQuantityCopy', 'poProjectNum', 'omsProjectNum'].includes(item.key));
        },
        splitBrandModalFilterData() {
            this.splitBrandAutoSelect();
            const { currentPage, pageSize } = this.splitBrandModal.settings;
            return this.splitBrandModal.tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize);
        },
        /* 是否需要报关标识 */
        isCustoms() {
            return this.INT_CUSTOMS_NO_MODIFY.find((item) => item.code === this.formItem.orgCode);
        },
        /* 已提交状态 */
        isSubmitted() {
            return this.formItem.imptStatus === 'SUBMITTED';
        },
        /* 是否需要撤回 */
        needWithdraw() {
            return this.isCustoms && this.isCustoms.value === 'N';
        },
        /* 成交数量汇总 按发票 */
        transQtyTotalByInvoice() {
            return deliveryTotalCount(this.block.selection, 'transactionQuantity');
        },
        /* 总净重汇总 按发票 */
        weightTotalByInvoice() {
            return deliveryTotalCount(this.block.selection, 'itemNetWeight');
        },
        /* 成交数量汇总 按订单 */
        dealQtyTotalByPo() {
            return deliveryTotalCount(this.block.selection, 'dealQuantity');
        },
        /* 总净重汇总 按订单 */
        weightTotalByPo() {
            return deliveryTotalCount(this.block.selection, 'itemNetWeight');
        },
        /* po类型自定义列顺序过滤字段 */
        byPoFilterColumns() {
            return this.block.columnsByPo.columns.filter((item) => ['closedCode', 'peripheralStatus', 'peripheralMessage', 'errorMessage', 'errorSolution', 'omsBrand', 'omsOrigin', 'canCreateNum', 'dealQuantityCopy'].includes(item.key)).map((item) => item.title);
        },
        isCn() {
            return this.$i18n.locale === 'zh-CN';
        },
        // /* 行数据成交数量汇总 */
        // lineQtyTotal() {
        //     return deliveryTotalCount(this.rowsTableData, 'dealQuantity');
        // },
        // /* 行数据总净重汇总 */
        // lineWeightTotal() {
        //     return deliveryTotalCount(this.rowsTableData, 'itemNetWeight');
        // },
    },
    data() {
        const validator1 = (rule, value, callback, source, options) => {
            let items = this.block.formData.items;
            let start = moment(this.getFormDataItemVal(items, 'startNeedByDate')).startOf('day')._d;
            let end = moment(this.getFormDataItemVal(items, 'endNeedByDate')).startOf('day')._d;
            let startItemCode = this.getFormDataItemVal(items, 'startItemCode');
            let endItemCode = this.getFormDataItemVal(items, 'endItemCode');
            if (new Date(start).getTime() > new Date(end).getTime()) {
                this.$Message.error(this.$t('importNoticeCommon.t37')); // 需求日期开始日期不能超过结束日期
                return false;
            } else if (!startItemCode && !endItemCode && moment(start).format('x') < moment(end).subtract('12', 'M').format('x')) {
                this.$Message.error(this.$t('importNoticeCommon.t38')); // 需求日期范围最大不能超过1年
                return false;
            } else if (startItemCode && endItemCode && moment(start).format('x') < moment(end).subtract('24', 'M').format('x')) {
                this.$Message.error(this.$t('importNoticeCommon.t39')); // 需求日期范围最大不能超过2年
                return false;
            } else {
                callback([]);
            }
        };
        return {
            errorStrongControl: false,
            gridApi: null,
            selection: [],
            splitBrandModal: {
                qtyRule: /^[0-9]+\.?[0-9]{0,2}$/,
                show: false,
                loading: false,
                selectLineId: '',
                allSelectFlag: false,
                lineIds: [],
                formData: {
                    row: 2,
                    items: [
                        {
                            title: this.$t('importNoticeCommon.t44'), // '发票号'
                            value: '',
                            field: 'supplierInvoiceNumber',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t9'), // '物料编码'
                            value: '',
                            field: 'itemCode',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t121'), // '拆分前品牌'
                            value: '',
                            field: 'brand',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t122'), // '拆分前原产地'
                            value: '',
                            field: 'origin',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t50'), // 'PO号'
                            value: '',
                            field: 'poNumber',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                    ]
                },
                columns: {
                    columns: [
                        {
                            type: 'selection',
                            width: 30,
                            align: 'center'
                        },
                        {
                            title: this.$t('importNoticeCommon.t44'), // 发票号
                            key: 'supplierInvoiceNumber',
                            minWidth: 120
                        },
                        {
                            title: this.$t('importNoticeCommon.t9'), // 物料编码
                            key: 'itemCode',
                            minWidth: 110
                        },
                        {
                            title: this.$t('importNoticeCommon.t123'), // 拆分前成交数量,
                            key: 'dealQuantity',
                            minWidth: 80,
                            align: 'right'
                        },
                        {
                            renderHeader: (h) => {
                                return this.getRedStar(h, this.$t('importNoticeCommon.t124')); // '本次成交数量'
                            },
                            title: this.$t('importNoticeCommon.t124'), // 本次成交数量,
                            key: 'detailDealQuantity',
                            minWidth: 80,
                            render: (h, params) => {
                                return h('Input', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        value: params.row.detailDealQuantity
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let value = event.target.value;
                                            let Max = params.row.dealQuantity;
                                            if (!this.splitBrandModal.qtyRule.test(value)) {
                                                this.$Modal.error({
                                                    title: this.$t('common.warn'),
                                                    content: this.$t('importNoticeCommon.t131')
                                                });
                                                event.target.value = '';
                                                params.row.detailDealQuantity = '';
                                            } else {
                                                if (Number(value) > Max) {
                                                    event.target.value = Max;
                                                    value = Max;
                                                }
                                                params.row.detailDealQuantity = value;
                                            }
                                            const { currentPage, pageSize } = this.splitBrandModal.settings;
                                            this.$set(this.splitBrandModal.tableData, params.index + (currentPage - 1) * pageSize, params.row);
                                            // this.splitBrandModal.tableData[params.index + (currentPage - 1) * pageSize] = params.row;
                                            this.splitBrandValidate(params.row);
                                        }
                                    }
                                });
                            }
                        },
                        {
                            renderHeader: (h) => {
                                return this.getRedStar(h, this.$t('importNoticeCommon.t125')); // '本次总净重'
                            },
                            title: this.$t('importNoticeCommon.t125'), // 本次总净重
                            key: 'detailItemNetWeight',
                            minWidth: 80,
                            render: (h, params) => {
                                return h('Input', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        value: params.row.detailItemNetWeight
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let value = event.target.value;
                                            if (!this.splitBrandModal.qtyRule.test(value)) {
                                                this.$Modal.error({
                                                    title: this.$t('common.warn'),
                                                    content: this.$t('importNoticeCommon.t131')
                                                });
                                                event.target.value = '';
                                                params.row.detailItemNetWeight = '';
                                            } else {
                                                params.row.detailItemNetWeight = value;
                                            }
                                            const { currentPage, pageSize } = this.splitBrandModal.settings;
                                            this.$set(this.splitBrandModal.tableData, params.index + (currentPage - 1) * pageSize, params.row);
                                            // this.splitBrandModal.tableData[params.index + (currentPage - 1) * pageSize] = params.row;
                                        }
                                    }
                                });
                            }
                        },
                        {
                            title: this.$t('importNoticeCommon.t126'), // 拆分前总净重
                            key: 'itemNetWeight',
                            minWidth: 80,
                            align: 'right'
                        },
                        {
                            title: this.$t('importNoticeCommon.t127'), // 拆分前品牌名称
                            key: 'brand',
                            minWidth: 120,
                            tooltip: true
                        },
                        {
                            title: this.$t('importNoticeCommon.t128'), // 拆分后品牌名称,
                            key: 'detailBrand',
                            minWidth: 100
                        },
                        {
                            title: this.$t('importNoticeCommon.t129'), // 拆分前产地,
                            key: 'origin',
                            minWidth: 120,
                            tooltip: true
                        },
                        {
                            title: this.$t('importNoticeCommon.t130'), // 拆分后产地,
                            key: 'detailOrigin',
                            minWidth: 100
                        },
                        {
                            title: this.$t('importNoticeCommon.t118'), // 箱号,
                            key: 'ctn',
                            minWidth: 100
                        },
                        {
                            title: this.$t('importNoticeCommon.t50'), // PO,
                            key: 'poNumber',
                            minWidth: 100
                        },
                        {
                            title: this.$t('importNoticeCommon.t51'), // PO行号,
                            key: 'poLineNumber',
                            minWidth: 60
                        },
                        {
                            title: this.$t('importNoticeCommon.t18'), // 物料描述,
                            key: 'itemName',
                            minWidth: 150,
                            tooltip: true
                        }
                    ]
                },
                selection: [],
                tableData: [],
                settings: {
                    needValidation: false,
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    needSearch: true,
                    currentPage: 1,
                    pageTotal: 0,
                    pageSize: 10,
                    pageSizeOpts: [10, 100, 300, 500],
                },
                tableButtons: {
                    customButtons: [
                        {
                            label: this.$t('common.saveBtn'), // 保存
                            type: 'primary',
                            icon: 'archive',
                            size: 'small',
                            disabled: true,
                            click: (button) => {
                                this.splitBrandSave(button);
                            }
                        },
                        {
                            label: this.$t('importNoticeCommon.t100'), // 导入
                            type: 'primary',
                            icon: 'archive',
                            size: 'small',
                            click: (button) => {
                                this.$refs.upload2.clearFiles();
                                this.splitBrandModal.import.show = true;
                            },
                        },
                        {
                            label: this.$t('common.exportExcelBtn'), // 导出
                            type: 'primary',
                            icon: 'archive',
                            size: 'small',
                            click: (button) => {
                                this.$set(button, 'loading', true);
                                axios.post('/gscint/purImptNotyDetailI/detailExport', {
                                    headerId: this.headerId,
                                    ...this.getFormDataVModel(this.splitBrandModal.formData.items)
                                }, {
                                    responseType: 'blob',
                                    headers: { 
                                        'Content-Type': 'application/json;charset=UTF-8' 
                                    }
                                })
                                .then((res) => {
                                    this.$set(button, 'loading', false);
                                    this.downloadFile(res.data, `${this.$t('importNoticeCommon.t120')}.xlsx`);
                                })
                                .catch(() => {
                                    this.$set(button, 'loading', false);
                                    this.showErrorTips();
                                });
                            }
                        }
                    ]
                },
                import: {
                    show: false,
                    loading: false,
                    url: '/gscint/excel/loadExcelData',
                    data: {
                        keyValue: JSON.stringify([
                            {
                                key: this.$t('importNoticeCommon.t124'), // 本次送货数量
                                value: 'detailDealQuantity',
                            },
                            {
                                key: this.$t('importNoticeCommon.t125'), // 本次总净重量
                                value: 'detailItemNetWeight',
                            },
                        ]),
                    },
                },
                selectAllFlag: false,
            },
            invoiceKeyWord: '',
            invoiceNoModal: {
                timer: null,
                show: false,
                loading: false,
                columns: [
                    {
                        title: this.$t('importNoticeCommon.t44'), // '发票号',
                        key: 'invoiceNo',
                        minWidth: 120
                    }
                ],
                data: [],
                backUpData: []
            },
            syncBsShow: false, // 是否显示同步保税属性
            headerId: '',
            routerParams: {},
            vendorCode: '',
            vendorName: '',
            orgList: [],
            cuxDeliveryAssociatedDecList: [], // 组织快码
            cuxInStatusList: [], // 单据状态
            cuxTradeModeList: [], // 贸易方式
            intTypeOfPakageList: [], // 包装种类
            // gscpotypeList: [], // 订单类型
            settings: {
                needValidation: false,
                needPager: true,
                showElevator: true,
                showSizer: true,
                currentPage: 1,
                pageTotal: 0,
                pageSize: 100,
                pageSizeOpts: [50, 100],
                needSearch: false
            },
            formItem: {
                // orgCode: '', // 库存组织
                orgName: '', // 组织名称,
                erpOrgId: '', // 组织id,
                vendorCode: '', // 供应商编码
                vendorName: '', // 供应商名称
                // imptNumber: '', // 通知书号(后端初始化)
                creationDate: '', // 创建日期
                imptStatus: '', // 单据状态
                tradingMode: '', // 贸易方式
                remarks: '', // 备注
                etd: '', // 预计发船日期
                eta: '', // 预计到港日期
                typeOfPackage: '', // 包装种类
                billNo: '', // 提运单号
                iEDate: '', // 进口日期
                customsNumber: '', // 报关单号
                createdBy: ''
            },
            formItemRules: {
                etd: [
                    {type: 'string', required: true, message: this.$t('importNoticeCommon.t3'), trigger: 'change'}
                ],
                eta: [
                    {type: 'string', required: true, message: this.$t('importNoticeCommon.t3'), trigger: 'change'}
                ]
            },
            readDisabled: false,
            uploadLoading: false,
            uploadFiles: [], // 通知书附件
            customsFiles: [], // 报关附件
            annexId: '', // 通知书附件ID
            fileTypeList: ['xls', 'xlsx', 'doc', 'docx', 'pdf', 'jpeg', 'jpg', 'bmp', 'png'],
            options: {
                disabledDate(date) {
                    var dt = new Date();
                    dt.setMonth(dt.getMonth() - 12);
                    return date && date.valueOf() < dt;
                }
            },
            loading: false,
            rowsColumns: [
                {
                    type: 'selection',
                    align: 'center',
                    width: 30
                },
                {
                    title: this.$t('importNoticeCommon.t81'), // 报关单项号/序号
                    type: 'index',
                    align: 'center',
                    width: 70
                },
                {
                    title: this.$t('importNoticeCommon.t9'), // '物料编码',
                    key: 'itemCode',
                    tooltip: true,
                    minWidth: 120
                },
                {
                    title: this.$t('importNoticeCommon.t162'), // '回料编码'
                    key: 'convertItemCode',
                    tooltip: true,
                    minWidth: 120,
                },
                {
                    title: this.$t('importNoticeCommon.t18'), // '物料描述',
                    key: 'itemName',
                    tooltip: true,
                    minWidth: 160
                },
                {
                    title: this.$t('importNoticeCommon.t11'), // 报关单号
                    key: 'customsNumber',
                    tooltip: true,
                    minWidth: 100,
                },
                {
                    title: this.$t('importNoticeCommon.t7'), // 单据状态
                    key: 'imptStatus',
                    minWidth: 80,
                    align: 'center',
                    render: (h, params) => {
                        const { imptStatus } = params.row;
                        if (imptStatus) {
                            return h('span', this.cuxInStatusList.find((item) => item.value === imptStatus).label);
                        }
                    },
                },
                {
                    renderHeader: (h) => {
                        return this.getRedStar(h, this.$t('importNoticeCommon.t41')); // '成交数量'
                    },
                    title: this.$t('importNoticeCommon.t41'), // '成交数量',
                    key: 'dealQuantity',
                    tooltip: true,
                    align: 'right',
                    minWidth: 100,
                    render: (h, params) => {
                        return h('span', params.row.dealQuantity || params.row.transactionQuantity);
                    }
                },
                {
                    renderHeader: (h) => {
                        return this.getRedStar(h, this.$t('importNoticeCommon.t119')); // '品牌'
                    },
                    title: this.$t('importNoticeCommon.t119'), // '品牌',
                    key: 'brand',
                    tooltip: true,
                    minWidth: 100
                },
                {
                    renderHeader: (h) => {
                        return this.getRedStar(h, this.$t('importNoticeCommon.t118')); // '箱号'
                    },
                    title: this.$t('importNoticeCommon.t118'), // '箱号',
                    key: 'ctn',
                    tooltip: true,
                    minWidth: 100
                },
                {
                    renderHeader: (h) => {
                        return this.getRedStar(h, this.$t('importNoticeCommon.t42')); // '原产地'
                    },
                    title: this.$t('importNoticeCommon.t42'), // '原产地',
                    key: 'origin',
                    tooltip: true,
                    minWidth: 100
                },
                {
                    renderHeader: (h) => {
                        return this.getRedStar(h, this.$t('importNoticeCommon.t43')); // '总净重'
                    },
                    title: this.$t('importNoticeCommon.t43'), // '总净重',
                    key: 'itemNetWeight',
                    tooltip: true,
                    align: 'right',
                    minWidth: 80
                },
                {
                    title: this.$t('importNoticeCommon.t163'), // '毛重',
                    key: 'grossWeight',
                    tooltip: true,
                    align: 'right',
                    minWidth: 80
                },
                {
                    renderHeader: (h) => {
                        return this.getRedStar(h, this.$t('importNoticeCommon.t44')); // '发票号'
                    },
                    title: this.$t('importNoticeCommon.t44'), // '发票号',
                    key: 'supplierInvoiceNumber',
                    tooltip: true,
                    minWidth: 100
                },
                {
                    renderHeader: (h) => {
                        return this.getRedStar(h, this.$t('importNoticeCommon.t117')); // '保税属性'
                    },
                    title: this.$t('importNoticeCommon.t117'), // '保税属性',
                    key: 'attribute3',
                    tooltip: true,
                    minWidth: 100,
                    render: (h, params) => {
                        let attribute3 = params.row.attribute3;
                        if (attribute3) {
                            return h('span', this.INT_BONDED_TYPE.find((item) => item.value === attribute3).email);
                        }
                    }
                },
                {
                    renderHeader: (h) => {
                        return this.getRedStar(h, this.$t('importNoticeCommon.t82')); // '发票项号'
                    },
                    title: this.$t('importNoticeCommon.t82'), // '发票项号'
                    key: 'supplierInvoiceItemNumber',
                    align: 'center',
                    tooltip: true,
                    minWidth: 100
                },
                {
                    renderHeader: (h) => {
                        return this.getRedStar(h, this.$t('importNoticeCommon.t45')); // '发票日期'
                    },
                    title: this.$t('importNoticeCommon.t45'), // '发票日期',
                    key: 'supplierInvoiceDate',
                    tooltip: true,
                    align: 'center',
                    minWidth: 110
                },
                // {
                //     title: this.$t('importNoticeCommon.t46'), // '贸易方式',
                //     key: 'tradingMode',
                //     tooltip: true,
                //     minWidth: 100,
                //     render: (h, params) => {
                //         return this.getKeyLabel(h, params, this.cuxTradeModeList, 'tradingMode');
                //     }
                // },
                {
                    title: this.$t('importNoticeCommon.t40'), // '单位',
                    key: 'itemUnit',
                    tooltip: true,
                    align: 'center',
                    minWidth: 70
                },
                // {
                //     title: this.$t('importNoticeCommon.t48'), // '成交总价',
                //     key: 'totalPrice',
                //     tooltip: true,
                //     align: 'center',
                //     minWidth: 100
                // },
                {
                    title: this.$t('importNoticeCommon.t49'), // '币种',
                    key: 'currency',
                    tooltip: true,
                    align: 'center',
                    minWidth: 100
                },
                {
                    title: this.$t('importNoticeCommon.t50'), // 'PO号',
                    key: 'poNumber',
                    sortable: true,
                    tooltip: true,
                    minWidth: 160
                },
                {
                    title: this.$t('importNoticeCommon.t51'), // 'PO行号',
                    key: 'poLineNumber',
                    sortable: true,
                    tooltip: true,
                    align: 'center',
                    minWidth: 100
                },
                {
                    title: this.$t('importNoticeCommon.t52'), // '采购员',
                    key: 'poBuyerName',
                    sortable: true,
                    tooltip: true,
                    minWidth: 90
                },
                {
                    title: this.$t('importNoticeCommon.t47'), // '成交单价',
                    key: 'dealUnitPrice',
                    tooltip: true,
                    align: 'right',
                    minWidth: 110
                },
                {
                    title: this.$t('importNoticeCommon.t164'), // '地板台',
                    key: 'platform',
                    tooltip: true,
                    align: 'right',
                    minWidth: 110
                },
                {
                    title: this.$t('importNoticeCommon.t66'), // '未完成数量'
                    key: 'unfinishedQuantiey',
                    align: 'right',
                    minWidth: 100,
                    // render: (h, params) => {
                    //     return h('span', this.numSub(Number(params.row.unfinishedQuantiey), Number(params.row.totalDealQuantity)));
                    // },
                    sortMethod: (a, b, type) => {
                        if (type === 'asc') {
                            return parseFloat(a) - parseFloat(b);
                        } else {
                            return parseFloat(b) - parseFloat(a);
                        }
                    }
                },
                {
                    title: this.$t('importNoticeCommon.t67'), // '已申请数量'
                    key: 'totalDealQuantity',
                    align: 'right',
                    minWidth: 90
                },
                {
                    title: this.$t('importNoticeCommon.t87'), // 提运单号
                    key: 'orders',
                    tooltip: true,
                    minWidth: 110,
                },
                {
                    title: this.$t('importNoticeCommon.t88'), // 进口日期
                    key: 'importDate',
                    align: 'center',
                    minWidth: 100,
                },
                {
                    title: this.$t('importNoticeCommon.t80'), // '操作',
                    key: 'opt',
                    sortable: false,
                    align: 'center',
                    minWidth: 70,
                    render: (h, params) => {
                        return h('Button', {
                            props: {
                                type: 'text',
                                icon: 'trash-b',
                                disabled: this.onlyRead
                            },
                            style: {padding: '5px'},
                            on: {
                                click: () => {
                                    this.$Modal.confirm({
                                        title: this.$t('common.warn'),
                                        content: this.$t('importNoticeCommon.t23'), // 确定要删除吗？
                                        onOk: () => {
                                            setTimeout(() => {
                                                this.handleDel(params.row.detailLineId);
                                            }, 100);
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            ],
            rowsTableData: [],
            showRowsTableData: [],
            block: {
                modal: false,
                formData: {
                    row: 3,
                    items: [
                        {
                            title: this.$t('importNoticeCommon.t59'), // '需求日期',
                            isDouble: true,
                            value: moment(new Date()).subtract(3, 'M')._d,
                            field: 'startNeedByDate',
                            type: 'datePicker',
                            style: 'width:100%',
                            labelWidth: 80,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            validators: {
                                required: {
                                    required: true,
                                    message: this.$t('importNoticeCommon.t4') // 请选择
                                }
                            },
                            options: {
                                type: 'date',
                                format: 'yyyy-MM-dd',
                                options: {
                                    disabledDate:() => {}
                                }
                            }
                        },
                        {
                            title: this.$t('importNoticeCommon.t61'), // 至需求日期
                            hide: true,
                            value: moment(new Date()).add(3, 'M')._d,
                            field: 'endNeedByDate',
                            type: 'datePicker',
                            style: 'width:100%',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            validators: {
                                required: {
                                    required: true,
                                    message: this.$t('importNoticeCommon.t4') // 请选择
                                },
                                range: {
                                    validator: validator1,
                                    trigger: 'change'
                                }
                            },
                            options: {
                                type: 'date',
                                format: 'yyyy-MM-dd',
                                options: {
                                    disabledDate:() => {}
                                }
                            }
                        },
                        {
                            title: this.$t('importNoticeCommon.t44'), // '发票号'
                            value: '',
                            placeholder: '',
                            field: 'invoiceNo',
                            readonly: true,
                            labelWidth: 80,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            validators: {
                                required: {
                                    required: true,
                                    message: this.$t('importNoticeCommon.t4') // 请选择
                                }
                            },
                            options: {
                                rows: 1
                            },
                            type: 'text',
                            icon: 'search',
                            canClick: true,
                            click: () => {
                                this.invoiceNoModal.show = true;
                                this.queryInvoiceNoList();
                                // if (this.$refs.pageForm.$refs.queryForm.validateForm()) {
                                //     this.sublibrarySetting.show = true;
                                // }
                            }
                        },
                        {
                            title: this.$t('importNoticeCommon.t10'), // '采购订单号'
                            value: '',
                            placeholder: '多个请用;(半角)隔开',
                            field: 'poNumber',
                            labelWidth: 80,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            blur: ({value}) => {
                                console.log('value:', value);
                                if (value && !this.validMaxLen(value)) {
                                    // 采购订单号筛选一次不能超过10个记录
                                    this.$Modal.error({
                                        title: this.$t('common.warn'),
                                        content: `${this.$t('importNoticeCommon.t107')}`
                                    });
                                }
                            },
                            options: {
                                rows: 1
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t62'), // '订单类型'
                            placeholder: '',
                            value: '',
                            field: 'poType',
                            disabled: false,
                            labelWidth: 90,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            methods: {
                                change: () => {}
                            },
                            options: {
                                multiple: false,
                                values: []
                            },
                            type: 'select',
                            validators: {
                                required: {
                                    required: false,
                                    message: this.$t('importNoticeCommon.t3') // '不能为空'
                                }
                            }
                        },
                        {
                            title: this.$t('importNoticeCommon.t27'), // '创建日期',
                            isDouble: true,
                            value: '',
                            field: 'startCreationDate',
                            type: 'datePicker',
                            style: 'width:100%',
                            labelWidth: 80,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            validators: {
                                required: {
                                    required: false,
                                    message: this.$t('importNoticeCommon.t4') // 请选择
                                }
                            },
                            options: {
                                type: 'date',
                                format: 'yyyy-MM-dd'
                            },
                            // change: (dateObj, time) => {}
                        },
                        {
                            title: this.$t('importNoticeCommon.t63'), // '至创建日期'
                            hide: true,
                            value: '',
                            field: 'endCreationDate',
                            type: 'datePicker',
                            style: 'width:100%',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            validators: {
                                required: {
                                    required: false,
                                    message: this.$t('importNoticeCommon.t4') // 请选择
                                }
                            },
                            options: {
                                type: 'date',
                                format: 'yyyy-MM-dd'
                            }
                        },
                        {
                            title: this.$t('importNoticeCommon.t64'), // '物料编码从'
                            isDouble: true,
                            value: '',
                            field: 'startItemCode',
                            disabled: false,
                            validators: [{
                                required: false,
                                pattern: /^[a-zA-Z0-9]+$/,
                                message: this.$t('importNoticeCommon.t6'), // 只能输入数字和英文
                                trigger: 'blur'
                            }],
                            labelWidth: 80,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            methods: {},
                            options: {
                                type: 'text',
                                rows: 1
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t65'), // '至物料编码'
                            hide: true,
                            value: '',
                            field: 'endItemCode',
                            disabled: false,
                            validators: [{
                                required: false,
                                pattern: /^[a-zA-Z0-9]+$/,
                                message: this.$t('importNoticeCommon.t6'), // 只能输入数字和英文
                                trigger: 'blur'
                            }],
                            labelWidth: 80,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            methods: {},
                            options: {
                                type: 'text',
                                rows: 1
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t106'), // 'PO贸易方式'
                            placeholder: '',
                            value: '',
                            field: 'tradingMode',
                            disabled: false,
                            filterable: true,
                            labelWidth: 90,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            methods: {
                                change: () => {}
                            },
                            options: {
                                multiple: false,
                                values: []
                            },
                            type: 'select',
                            validators: {
                                required: {
                                    required: false,
                                    message: this.$t('importNoticeCommon.t3') // '不能为空'
                                }
                            }
                        }
                    ]
                },
                formData2: {
                    row: 2,
                    items: [
                        {
                            title: this.$t('importNoticeCommon.t44'), // '发票号'
                            value: '',
                            field: 'invoiceNo',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text',
                            validators: {
                                required: {
                                    required: true,
                                    message: this.$t('importNoticeCommon.t3') // 不能为空
                                }
                            }
                        },
                        {
                            title: this.$t('importNoticeCommon.t50'), // 'PO号'
                            value: '',
                            field: 'poNumber',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t9'), // '物料编码'
                            value: '',
                            field: 'itemCode',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t118'), // '箱号'
                            value: '',
                            field: 'ctn',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t119'), // '品牌'
                            value: '',
                            field: 'brand',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('是否异常'), // 是否异常
                            value: '',
                            field: 'error',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2,
                            },
                            options: {
                                multiple: false,
                                values: [
                                    {
                                        label: this.$t('TMRollingForecast.t10'),
                                        value: 'Y',
                                    },
                                    {
                                        label: this.$t('TMRollingForecast.t11'),
                                        value: 'N',
                                    },
                                ],
                            },
                            type: 'select',
                        },
                    ],
                },
                columns: {
                    columns: [
                        {
                            type: 'selection',
                            align: 'center',
                            width: 35
                        },
                        {
                            title: this.$t('createDeliveryOrderToInformView.t48'), // 序号
                            type: 'index',
                            align: 'center',
                            width: 30,
                            key: 'index',
                        },
                        {
                            title: this.$t('importNoticeCommon.t9'), // '物料编码'
                            key: 'itemCode',
                            tooltip: true,
                            minWidth: 80
                        },
                        {
                            title: this.$t('importNoticeCommon.t162'), // '回料编码'
                            key: 'convertItemCode',
                            tooltip: true,
                            minWidth: 110,
                        },
                        {
                            title: this.$t('importNoticeCommon.t18'), // '物料描述'
                            key: 'itemName',
                            tooltip: true,
                            minWidth: 160
                        },
                        {
                            title: this.$t('importNoticeCommon.t50'), // PO号/采购订单号
                            key: 'poNumber',
                            align: 'center',
                            tooltip: true,
                            width: 70
                        },
                        {
                            title: this.$t('importNoticeCommon.t114'), // OMS发票剩余数量
                            key: 'dealQuantityCopy',
                            width: 60,
                            align: 'right',
                        },
                        {
                            title: this.$t('importNoticeCommon.t51'), // 'PO行号'
                            key: 'poLineNumber',
                            tooltip: true,
                            align: 'center',
                            width: 40
                        },
                        {
                            renderHeader: (h) => {
                                return h('span', this.isPoType ? this.$t('importNoticeCommon.t66') : this.$t('importNoticeCommon.t137'));
                            },
                            title: this.$t('importNoticeCommon.t66'), // '未完成数量' PO剩余数量
                            key: 'unfinishedQuantiey',
                            align: 'right',
                            width: 50,
                            // render: (h, params) => {
                            //     return h('span', this.numSub(Number(params.row.unfinishedQuantiey), Number(params.row.totalDealQuantity)));
                            // },
                            sortMethod: (a, b, type) => {
                                if (type === 'asc') {
                                    return parseFloat(a) - parseFloat(b);
                                } else {
                                    return parseFloat(b) - parseFloat(a);
                                }
                            }
                        },
                        {
                            title: this.$t('importNoticeCommon.t139'), // '剩余可创建数量'
                            key: 'canCreateNum',
                            align: 'right',
                            width: 60,
                            render: (h, params) => {
                                const { unfinishedQuantiey, dealQuantityCopy } = params.row;
                                return h('span', (unfinishedQuantiey && dealQuantityCopy && unfinishedQuantiey - dealQuantityCopy) || 0);
                            },
                        },
                        {
                            title: this.$t('importNoticeCommon.t67'), // '已申请数量'
                            key: 'totalDealQuantity',
                            align: 'right',
                            width: 50,
                            render: (h, params) => {
                                const { totalDealQuantity, deliveryQuantity } = params.row;
                                return h('span', this.isPoType ? totalDealQuantity : deliveryQuantity);
                            },
                        },
                        {
                            renderHeader: (h) => {
                                return this.getRedStar(h, this.$t('importNoticeCommon.t118')); // '箱号'
                            },
                            title: this.$t('importNoticeCommon.t118'), // 箱号
                            key: 'ctn',
                            minWidth: 120,
                            tooltip: true,
                            render: (h, params) => {
                                if (this.createType === 'po') {
                                    return h('Input', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            value: params.row.ctn,
                                            maxlength: 30
                                        },
                                        on: {
                                            'on-blur': (event) => {
                                                params.row.ctn = event.target.value;
                                                this.updateRowData(params.index, params.row);
                                            }
                                        }
                                    })
                                } else {
                                    return h('span', params.row.ctn);
                                }
                            }
                        },
                        {
                            renderHeader: (h) => {
                                return this.getRedStar(h, this.$t('importNoticeCommon.t41')); // '成交数量'
                            },
                            title: this.$t('importNoticeCommon.t41'), // '成交数量'
                            key: 'dealQuantity',
                            align: 'right',
                            width: 70,
                            render: (h, params) => {
                                if (this.createType === 'po') {
                                    // 未完成数量-已申请数量，可以修改数量，但不能超量(要求强一致性)
                                    let maxVal = Number(params.row.unfinishedQuantiey);
                                    let disabled = Number(params.row.unfinishedQuantiey) <= 0;
                                    let ipt = h('Input', {
                                        props: {
                                            disabled: disabled,
                                            type: 'text',
                                            size: 'small',
                                            value: params.row.dealQuantity
                                        },
                                        on: {
                                            'on-blur': (event) => {
                                                let iptVal = event.target.value;
                                                if (isNaN(event.target.value) || iptVal <= 0) {
                                                    this.showTips(this.$t('importNoticeCommon.t68')); // 成交数量不允许小于等于0
                                                    event.target.value = '';
                                                    params.row.dealQuantity = null;
                                                    return false;
                                                }
                                                // if (!this.validatePositive(iptVal)) {
                                                //     this.showTips(this.$t('importNoticeCommon.t69')); // 请输入正整数
                                                //     event.target.value = '';
                                                //     params.row.dealQuantity = null;
                                                //     return false;
                                                // }
                                                if (iptVal > maxVal) {
                                                    this.showTips(this.$t('importNoticeCommon.t70') + maxVal); // `成交数量不允许超过${maxVal}`
                                                }
                                                iptVal =  parseFloat(iptVal);
                                                params.row.dealQuantity = parseFloat(iptVal.toFixed(2));
                                                params.row.itemNetWeight = (Number(params.row.itemNetWeightSingle) * params.row.dealQuantity).toFixed(2);
                                                    // params.row.itemNetWeight = (Number(params.row.singNw) * params.row.dealQuantity).toFixed(2);
                                                params.row.totalPrice = (params.row.dealUnitPrice * params.row.dealQuantity).toFixed(2);
                                                this.updateRowData(params.index, params.row);
                                            }
                                        }
                                    });
                                    return ipt;
                                } else {
                                    return h('Input', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            value: params.row.transactionQuantity,
                                            disabled: true
                                        },
                                        on: {
                                            // 'on-blur': (event) => {
                                            //     let {dealQuantityCopy, unfinishedQuantiey} = params.row;
                                            //     let iptVal = event.target.value;
                                            //     if (isNaN(iptVal) || iptVal <= 0) {
                                            //         this.showTips(this.$t('importNoticeCommon.t68')); // 成交数量不允许小于等于0
                                            //         event.target.value = '';
                                            //     }
                                            //     if (Number(iptVal) > Number(dealQuantityCopy) || Number(iptVal) > Number(unfinishedQuantiey)) {
                                            //         this.showTips(this.$t('importNoticeCommon.t116'));
                                            //         event.target.value = '';
                                            //     }
                                            //     params.row.dealQuantity = event.target.value ? Number(event.target.value) : '';
                                            //     if (params.row.dealQuantity) {
                                            //         params.row.totalPrice = (params.row.dealUnitPrice * params.row.dealQuantity).toFixed(2);
                                            //     }
                                            //     this.block.tableData[params.index] = params.row;
                                            // }
                                        }
                                    })
                                }
                            }
                        },
                        {
                            renderHeader: (h) => {
                                return this.getRedStar(h, this.$t('importNoticeCommon.t119')); // '品牌'
                            },
                            title: this.$t('importNoticeCommon.t119'), // 品牌
                            key: 'brand',
                            minWidth: 100,
                            render: (h, params) => {
                                // if (this.createType === 'po') {
                                // } else {
                                //     return h('span', params.row.brand);
                                // }
                                return h('Input', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        value: params.row.brand,
                                        maxlength: 30
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            params.row.brand = event.target.value;
                                            this.updateRowData(params.index, params.row);
                                        }
                                    }
                                })
                            }
                        },
                        {
                            renderHeader: (h) => {
                                return this.getRedStar(h, this.$t('importNoticeCommon.t42')); // '原产地'
                            },
                            title: this.$t('importNoticeCommon.t42'), // 原产地
                            key: 'origin',
                            align: 'center',
                            tooltip: true,
                            minWidth: 70,
                            render: (h, params) => {
                                if (this.createType === 'po') {
                                    let options = [];
                                    this.INT_ORIGIN.forEach(({value, label}) => {
                                        options.push(
                                            h('Option', {
                                                props: {
                                                    value,
                                                    label
                                                }
                                            })
                                        )
                                    });
                                    return h('Select', {
                                        props: {
                                            size: 'small',
                                            filterable: true,
                                            placement: 'bottom',
                                            transfer: true,
                                            value: params.row.origin,
                                        },
                                        on: {
                                            'on-change': (val) => {
                                                params.row.origin = val;
                                                this.updateRowData(params.index, params.row);
                                            }
                                        }
                                    }, options)
                                // eslint-disable-next-line no-else-return
                                } else {
                                    return h('Input', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            value: params.row.origin,
                                            maxlength: 30
                                        },
                                        on: {
                                            'on-blur': (event) => {
                                                params.row.origin = event.target.value;
                                                this.updateRowData(params.index, params.row);
                                            }
                                        }
                                    })
                                }
                            }
                        },
                        {
                            renderHeader: (h) => {
                                return this.getRedStar(h, this.$t('importNoticeCommon.t43')); // '总净重'
                            },
                            title: this.$t('importNoticeCommon.t43') + '(KG)', // '总净重'
                            key: 'itemNetWeight',
                            align: 'center',
                            minWidth: 80,
                            render: (h, params) => {
                                return h('Input', {
                                    props: {
                                        disabled: false,
                                        type: 'text',
                                        size: 'small',
                                        value: params.row.itemNetWeight
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let iptVal = event.target.value;
                                            if (isNaN(event.target.value) || iptVal <= 0) {
                                                this.showTips(this.$t('importNoticeCommon.t43') + this.$t('importNoticeCommon.t83')); // 总净重不允许小于等于0
                                                event.target.value = '';
                                                params.row.itemNetWeight = null;
                                                return false;
                                            }
                                            params.row.itemNetWeight = event.target.value;
                                            this.updateRowData(params.index, params.row);
                                        }
                                    }
                                });
                            }
                        },
                        {
                            // renderHeader: (h) => {
                            //     return this.getRedStar(h, this.$t('importNoticeCommon.t82')); // '发票项号'
                            // },
                            title: this.$t('importNoticeCommon.t163'), // '毛重'
                            key: 'grossWeight',
                            align: 'center',
                            tooltip: true,
                            minWidth: 110,
                            render: (h, params) => {
                                return h('Input', {
                                    props: {
                                        disabled: false,
                                        type: 'text',
                                        size: 'small',
                                        maxlength: 32,
                                        value: params.row.grossWeight
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            params.row.grossWeight = event.target.value;
                                            this.updateRowData(params.row);
                                        }
                                    }
                                });
                            }
                        },
                        {
                            renderHeader: (h) => {
                                return this.getRedStar(h, this.$t('importNoticeCommon.t44')); // '发票号'
                            },
                            title: this.$t('importNoticeCommon.t44'), // '发票号'
                            key: 'supplierInvoiceNumber',
                            align: 'center',
                            tooltip: true,
                            minWidth: 140,
                            render: (h, params) => {
                                return h('Input', {
                                    props: {
                                        disabled: true,
                                        type: 'text',
                                        size: 'small',
                                        value: params.row.supplierInvoiceNumber
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            params.row.supplierInvoiceNumber = event.target.value;
                                            this.updateRowData(params.index, params.row);
                                        }
                                    }
                                });
                            }
                        },
                        {
                            // renderHeader: (h) => {
                            //     return this.getRedStar(h, this.$t('importNoticeCommon.t82')); // '发票项号'
                            // },
                            title: this.$t('importNoticeCommon.t82'), // '发票项号'
                            key: 'supplierInvoiceItemNumber',
                            align: 'center',
                            tooltip: true,
                            minWidth: 110,
                            render: (h, params) => {
                                return h('Input', {
                                    props: {
                                        disabled: false,
                                        type: 'text',
                                        size: 'small',
                                        maxlength: 32,
                                        value: params.row.supplierInvoiceItemNumber
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            params.row.supplierInvoiceItemNumber = event.target.value;
                                            this.updateRowData(params.index, params.row);
                                        }
                                    }
                                });
                            }
                        },
                        {
                            renderHeader: (h) => {
                                return this.getRedStar(h, this.$t('importNoticeCommon.t45')); // '发票日期'
                            },
                            title: this.$t('importNoticeCommon.t45'), // '发票日期'
                            key: 'supplierInvoiceDate',
                            align: 'center',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                return h('DatePicker', {
                                    props: {
                                        type: 'date',
                                        size: 'small',
                                        format: 'yyyy-MM-dd',
                                        value: params.row.supplierInvoiceDate,
                                        transfer: true,
                                    },
                                    on: {
                                        'on-change': (data) => {
                                            params.row.supplierInvoiceDate = data;
                                            this.updateRowData(params.index, params.row);
                                        }
                                    }
                                });
                            }
                        },
                        {
                            title: this.$t('importNoticeCommon.t164'), // '地板台'
                            key: 'platform',
                            align: 'center',
                            tooltip: true,
                            minWidth: 100
                        },
                        {
                            title: this.$t('importNoticeCommon.t49'), // '币种'
                            key: 'currency',
                            align: 'center',
                            tooltip: true,
                            width: 40
                        },
                        {
                            title: this.$t('importNoticeCommon.t40'), // '单位'
                            key: 'itemUnit',
                            align: 'center',
                            tooltip: true,
                            width: 40
                        },
                        {
                            title: this.$t('importNoticeCommon.t48'), // '成交总价'
                            key: 'totalPrice',
                            align: 'center',
                            tooltip: true,
                            width: 50
                        },
                        {
                            title: this.$t('importNoticeCommon.t52'), // '采购员'
                            key: 'poBuyerName',
                            tooltip: true,
                            minWidth: 50
                        },
                        {
                            title: this.$t('importNoticeCommon.t106'), // 'PO贸易方式',
                            key: 'tradingMode',
                            align: 'center',
                            tooltip: true,
                            minWidth: 80,
                            render: (h, params) => {
                                return this.getKeyLabel(h, params, this.cuxTradeModeList, 'tradingMode');
                            }
                        },
                        {
                            title: this.$t('importNoticeCommon.t47'), // '成交单价'
                            key: 'dealUnitPrice',
                            align: 'center',
                            tooltip: true,
                            minWidth: 50
                        },
                        {
                            title: this.$t('importNoticeCommon.t157'), // OMS品牌
                            key: 'omsBrand',
                            minWidth: 100,
                            tooltip: true,
                        },
                        {
                            title: this.$t('importNoticeCommon.t158'), // OMS原产地
                            key: 'omsOrigin',
                            minWidth: 100,
                            tooltip: true,
                        },
                        {
                            title: this.$t('importNoticeCommon.t140'), // PO状态
                            key: 'closedCode',
                            width: 40,
                        },
                        {
                            title: this.$t('importNoticeCommon.t153'), // OMS超发回写状态
                            key: 'peripheralStatus',
                            minWidth: 100,
                        },
                        {
                            title: this.$t('importNoticeCommon.t154'), // OMS超发回写消息
                            key: 'peripheralMessage',
                            minWidth: 100,
                        },
                        {
                            title: this.$t('importNoticeCommon.t156'), // 错误原因
                            key: 'errorMessage',
                            minWidth: 200,
                            tooltip: true,
                        },
                        {
                            title: this.$t('importNoticeCommon.t155'), // 解决方案
                            key: 'errorSolution',
                            minWidth: 200,
                            tooltip: true,
                        },
                        {
                            title: this.$t('importNoticeCommon.t165'), // PO项目号
                            key: 'poProjectNum',
                            minWidth: 100,
                            tooltip: true,
                        },
                        {
                            title: this.$t('importNoticeCommon.t166'), // OMS项目号
                            key: 'omsProjectNum',
                            minWidth: 100,
                            tooltip: true,
                        },
                        // {
                        //     title: this.$t('importNoticeCommon.t59'), // '需求日期'
                        //     key: 'poNeedDate',
                        //     tooltip: true,
                        //     minWidth: 130
                        // }
                    ]
                },
                columnsByPo: {
                    columns: [],
                },
                tableData: [],
                tableDataBackUp: [],
                loading: false,
                settings: {
                    needPager: false,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [50, 100],
                    needSearch: true,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 100,
                    total: null
                },
                selection: [],
                selectAllFlag: false
            },
            /** 导入 */
            uploadModal: false,
            current1: 0,
            uploadFileLoading: false,
            excelImportTips: '',
            importLock: true,
            INT_ORIGIN: [],
            createType: 'po', // 创建方式
            requiredKeys: ['dealQuantity', 'origin', 'itemNetWeight', 'supplierInvoiceNumber', 'supplierInvoiceDate', 'ctn', 'brand'],
            INT_BONDED_TYPE: [],
            INT_CUSTOMS_NO_MODIFY: [],
            mainLineQuery: {
                formData: {
                    row: 2,
                    items: [
                        {
                            title: this.$t('importNoticeCommon.t144'), // OMS发票号
                            value: '',
                            field: 'supplierInvoiceNumber',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t50'), // PO号
                            value: '',
                            field: 'poNumber',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t9'), // 物料编码
                            value: '',
                            field: 'itemCode',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t118'), // 箱号
                            value: '',
                            field: 'ctn',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t11'), // 报关单号
                            value: '',
                            field: 'customsNumber',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text'
                        },
                        {
                            title: this.$t('importNoticeCommon.t145'), // 状态
                            value: '',
                            field: 'imptStatus',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                multiple: false,
                                values: []
                            },
                            type: 'select',
                        },
                    ],
                },
            },
            customsNumberModal: {
                show: false,
                loading: false,
                customsNumber: '',
            },
            importCustomsNumberModal: {
                show: false,
                loading: false,
                url: '/gscint/imptNotyLine/importLineList',
                data: {},
            },
            lineQtyTotal: 0,
            lineWeightTotal: 0,
        }
    },
    watch: {
        'splitBrandModal.selection' (newVal) {
            this.$set(this.splitBrandModal.tableButtons.customButtons[0], 'disabled', newVal.length === 0);
        },
        'splitBrandModal.show' (newVal) {
            if (newVal) {
                this.splitBrandOnSubmit();
            }
        },
        'block.modal' (nVal) {
            if (!nVal) {
                this.importLock = true;
                this.blockModalCancel();
            } else {
                this.importLock = false;
            }
            try {
                this.$refs.pageForm.$refs.queryForm.$refs.formData.resetFields();
            } catch (err) {
                console.log(err);
            }
        },
        // createType (newVal) {
        //     if (newVal === 'po') {
        //         // 过滤商业发票号字段
        //         this.block.columns.columns = this.block.columns.columns.filter((item) => ![this.$t('importNoticeCommon.t114'), this.$t('importNoticeCommon.t139')].includes(item.title));
        //     } else {
        //         this.block.columns.columns.splice(5, 0, {
        //             title: this.$t('importNoticeCommon.t114'), // OMS发票剩余数量
        //             key: 'dealQuantityCopy',
        //             minWidth: 50,
        //             align: 'right'
        //         });
        //     }
        //     this.block.columns.columns = this.block.columns.columns.map((item) => {
        //         // if (item.key === 'dealQuantity') {
        //         //     item.title = newVal === 'po' ? '' : this.$t('importNoticeCommon.t114');
        //         //     item.minWidth = newVal === 'po' ? 0 : 100;
        //         // }
        //         if (item.title === this.$t('importNoticeCommon.t67')) { // 已申请数量
        //             item.key = newVal === 'po' ? 'totalDealQuantity' : 'deliveryQuantity';
        //         }
        //         return item;
        //     });
        // },
        'invoiceNoModal.show' (newVal) {
            if (!newVal) {
                this.invoiceKeyWord = '';
            }
        },
        'customsNumberModal.show'(newVal) {
            if(!newVal) {
                this.customsNumberModal.customsNumber = '';
            }
        },
        'importCustomsNumberModal.show'(newVal) {
            if (newVal) {
                this.importCustomsNumberModal.data.headerId = this.headerId;
                this.$refs.upload3.clearFiles();
            }
        },
    },
    methods: {
        validMaxLen(val) {
            let isOK = true;
            let arr = val ? val.split(';') : [];
            if (arr.length > 10) {
                isOK = false;
            }
            console.log(arr.length, arr);
            return isOK;
        },
        /** 清除**/
        handleConfirmReset() {
            this.$refs['formItemRef'].resetFields();
        },
        goBack() {
            setTimeout(() => {
                this.$router.push({name: 'importNoticeQuery'});
            }, 0);
            this.$store.dispatch('closeTag', this.$route);
        },
        getRedStar(h, title) {
            let text = '*';
            if (this.createType !== 'po') {
                if (title === this.$t('importNoticeCommon.t82')) {
                    text = '';
                }
            }
            return h('span', [
                h('Label', {
                    style: {color: '#ff0000'}
                }, text),
                h('span', {}, title)
            ]);
        },
        getKeyLabel(h, params, list, key) {
            let name = (list.find(item => item.value === params.row[key]) || {}).label || '';
            return h('span', name);
        },
        /* 删除行 */
        handleDel(detailLineId) {
            axios.get(`/gscint/imptNotyLine/lineDel?detailLineId=${detailLineId}`)
            .then(res => {
                try {
                    if (res.data.data.success) {
                        this.getImptNotyLine();
                    }
                } catch (error) {
                    console.log(error);
                }
            });
        },
        showTips(msg) {
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: msg
            });
        },
        validBlock() {
            let flag = true;
            this.$refs.pageForm.$refs.queryForm.validateForm((valid) => {
                if (valid) {
                    flag = true;
                    let startNeedByDate = this.getFormDataItemObj(this.block.formData.items, 'startNeedByDate').value;
                    let endNeedByDate = this.getFormDataItemObj(this.block.formData.items, 'endNeedByDate').value;
                    let poNumber = this.getFormDataItemObj(this.block.formData.items, 'poNumber').value;
                    // if (!startNeedByDate || !endNeedByDate) {
                    //     this.$Message.error('需求日期区间必选');
                    //     flag = false;
                    //     return false;
                    // }
                    if (startNeedByDate && endNeedByDate) {
                        if (this.block.formData.items[6].value || this.block.formData.items[7].value) {
                            if (moment(startNeedByDate).format('x') < moment(endNeedByDate).subtract('24', 'M').format('x')) {
                                this.$Message.error(this.$t('importNoticeCommon.t71')); // 需求日期范围最大不能超过24个月
                                flag = false;
                            }
                        } else {
                            if (moment(startNeedByDate).format('x') < moment(endNeedByDate).subtract('24', 'M').format('x')) {
                                this.$Message.error(this.$t('importNoticeCommon.t72')); // 需求日期范围最大不能超过12个月
                                flag = false;
                            }
                        }
                    }
                    if (poNumber && !this.validMaxLen(poNumber)) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: `${this.$t('importNoticeCommon.t107')}`
                        });
                        flag = false;
                    }
                } else {
                    flag = false;
                }
            });
            return flag;
        },
        onSubmit(page, pageSize, condition) {
            console.log('pageSize:', pageSize);
            this.block.settings.currentPage = 1;
            this.block.settings.pageSize = pageSize;
            this.onSearch();
        },
        /** 搜索 */
        onSearch() {
            if (!this.validBlock()) {
                return false;
            }
            this.block.loading = true;
            this.block.selection = [];
            this.block.tableData = [];
            let params = {
                headerId: this.headerId || null
            };
            let url;
            /* 是否按采购订单创建 */
            if (this.createType === 'po') {
                url = '/gscint/poinTemp/orderPoList';
                this.block.formData.items.forEach((item) => {
                    if (item.field) {
                        params[item.field] = item.value;
                    }
                });
                params.tradingMode = params.tradingMode === 'null' ? '' : params.tradingMode;
                // let ids = this.rowsTableData.map(i => i.poLineId);
                // params.poLineIdList = ids;
                params = {
                    ...params,
                    orgCode: this.formItem.orgCode,
                    page: this.block.settings.currentPage,
                    pageSize: 999999
                }
            } else {
                url = '/gscint/imptNotyHeader/queryInvoiceNo';
                params = {
                    ...params,
                    ...this.getFormDataVModel(this.block.formData2.items),
                    orgCode: this.formItem.orgCode,
                }
                let removeData = [];
                if (this.rowsTableData.length > 0) {
                    this.rowsTableData.forEach((item) => {
                        removeData.push(item.poLineId);
                    });
                    params.poLineIds = removeData.join();
                }
            }
            axios.post(url, {
                vendorCode: this.vendorCode,
                ...params,
                language: this.$i18n.locale
            }).then(res => {
                try {
                    this.block.loading = false;
                    this.importLock = false;
                    let rep = res.data;
                    if (rep.data.success === true) {
                        this.errorStrongControl = rep.data?.map?.errorStrongControl === 'Y';
                        let list = this.createType === 'po' ? rep.data.data.rows : rep.data.datas;
                        this.block.settings.currentPage = 1;
                        this.block.settings.total = list.length;
                        list.map((item, index) => {
                            /* 原产地默认为中国 */
                            item.origin = item.origin || 'China';
                            if (this.createType === 'po') {
                                // let cal = this.numSub(Number(item.unfinishedQuantiey), Number(item.totalDealQuantity));
                                // if (cal > 0) {
                                //     item.dealQuantity = cal;
                                // } else {
                                //     item.dealQuantity = null;
                                // }
                                item.dealQuantity = item.unfinishedQuantiey;
                                // 总净重=成交数量*单个净重，itemNetWeightSingle单价净重
                                item.itemNetWeight = item.itemNetWeightSingle ? (Number(item.itemNetWeightSingle) * item.dealQuantity).toFixed(2) : null;
                                item.supplierInvoiceNumber = this.getFormDataItemVal(this.block.formData.items, 'invoiceNo');
                            } else {
                                // 商业发票数量 < 订单的未完成数量 自动带成交数量，数量为‘商业发票数量’
                                item.dealQuantityCopy = item.dealQuantity;
                                // if (item.unfinishedQuantiey || item.unfinishedQuantiey === 0) {
                                //     if (Number(item.unfinishedQuantiey) < Number(item.dealQuantity)) {
                                //         item.dealQuantity = '';
                                //     }
                                // }
                            }
                            item.totalPrice = (item.dealUnitPrice * item.dealQuantity).toFixed(2);
                            item.origin = item.origin || '';
                            /* 前端生成唯一ID */
                            item.uuId = String(index);
                            /* 增加序号 */
                            item.index = index + 1;
                            return item;
                        });
                        if (this.createType !== 'po') {
                            debugger;
                            this.block.tableDataBackUp = list;
                            list = list.filter((item) => params.error === 'Y' ? item.errorMessage : (params.error === '' ? true : !item.errorMessage));
                        }
                        this.block.tableData = list;
                    } else {
                        this.showTips(rep.data.message);
                    }
                } catch (error) {
                    console.log('onSearch_error:', error);
                }
            }).catch(() => {
                this.block.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        onSelectionChange(selection) {
            // console.log('block.selection::', selection);
            // this.block.selection = selection;
        },
        modalOnSelect(selection) {
            this.block.selection = selection;
        },
        blockModalCancel() {
            this.block.modal = false;
            this.importLock = true;
            this.block.selection = [];
            this.block.tableData = [];
            this.block.settings.currentPage = 1;
            this.block.settings.total = 0;
        },
        /**确定添加_进口通知书明细 */
        async handleDetailSure() {
            let selection = this.gridApi.getSelectedRows();
            const comfirm = () => {
                this.block.loading = true;
                setTimeout(() => {
                    for (let i = 0; i < selection.length; i++) {
                        const selectItem = selection[i];
                        // let index = table.findIndex(({uuId}) => uuId === selectItem.uuId);
                        let {dealQuantity, unfinishedQuantiey, origin, itemNetWeight, supplierInvoiceNumber, supplierInvoiceDate, ctn, brand, uuId} = selectItem;
                        itemNetWeight = Number(itemNetWeight);
                        let content = this.$t('importNoticeCommon.t73') + this.$t('importNoticeCommon.t74') + ' ' + this.$t('importNoticeCommon.t75') + `${+uuId + 1} ` + this.$t('importNoticeCommon.t76');
                        if (!Number(dealQuantity) || !supplierInvoiceNumber || !supplierInvoiceDate || !origin || !ctn || !brand) { // 成交数量、发票号、发票日期、原产地、箱号、品牌
                            this.$Modal.warning({
                                title: this.$t('common.warn'),
                                content
                            });
                            this.block.loading = false;
                            return false;
                        }
                        if (Number(dealQuantity) > Number(unfinishedQuantiey) && this.isPoType) { // po类型才做校验
                            this.showTips(this.$t('importNoticeCommon.t70') + unfinishedQuantiey);
                            this.block.loading = false;
                            return false;
                        }
                        if (!itemNetWeight || itemNetWeight <= 0) { // 总净重
                            if (itemNetWeight < 0) {
                                this.showTips(this.$t('importNoticeCommon.t43') + this.$t('importNoticeCommon.t83')); // 总净重不允许小于等于0
                            } else {
                                this.$Modal.warning({
                                    title: this.$t('common.warn'),
                                    content
                                });
                            }
                            this.block.loading = false;
                            return false;
                        }
                        if (!this.isPoType) {
                            const rule = /^(?!.*,,)(?!.*,\s)(?!.*\s,).*[a-zA-Z0-9,\u4e00-\u9fa5\s()、]+$/;
                            const rule2 = /^(?!\s+$).+/;
                            if (!rule.test(brand) || !rule2.test(brand) || !rule.test(origin) || !rule2.test(origin) || (brand.split(',').length !== origin.split(',').length)) {
                                /* 品牌产地信息不正确
                                   品牌产地英文逗号数量需一致
                                */
                                this.$Modal.warning({
                                    title: this.$t('common.warn'),
                                    content: `${this.$t('importNoticeCommon.t75')}${Math.ceil((+uuId + 1) / this.block.settings.pageSize)}${this.$t('importNoticeCommon.t143')}${this.$t('importNoticeCommon.t75')}${i + 1}${this.$t('importNoticeCommon.t76')}${this.$t('importNoticeCommon.t142')}`,
                                });
                                this.block.loading = false;
                                return false;
                            }
                        }
                    }
                    let lines = this.block.tableData.filter(({uuId}) => selection.find((selectItem) => uuId === selectItem.uuId));
                    // this.rowsTableData = sArr.concat(this.rowsTableData);
                    this.block.selection = [];
                    this.block.tableData = [];
                    // this.blockDataHandle2(this.settings.currentPage, this.settings.pageSize);
                    const closeWin = () => {
                        this.block.modal = false;
                        this.block.loading = false;
                    }
                    this.handlSave('save', lines)
                    .then(() => {
                        closeWin();
                    })
                    .catch(() => {
                        closeWin();
                    });
                }, 500);
            }
            // if (this.block.selection.length <= 5000) {
            //     comfirm();
            // } else {
            //     this.$Modal.confirm({
            //         content: this.$t('importNoticeCommon.t138'),
            //         onOk: () => {
            //             comfirm();
            //         }
            //     })
            // }
            if (this.createType === 'po') {
                comfirm();
            } else {
                if (this.block.tableDataBackUp.some((item) => item.errorMessage && item.ignoreErrorCanSubmit !== 'Y')) {
                    const content = this.$t('DeliveryOrderQuery.t57') + selection[0].supplierInvoiceNumber + this.$t('存在异常数据，请检查！');
                    const searchFun = () => {
                        this.getFormDataItemObj(this.block.formData2.items, 'error').value = 'Y';
                        this.onSearch();  
                    };
                    if (this.errorStrongControl) {
                            this.$Modal.warning({
                                content,
                                okText: this.$t('异常查看'),
                                onOk: () => {
                                    searchFun();
                                },
                            });
                            return;
                    }
                    this.$Modal.confirm({
                        content,
                        okText: this.$t('继续创建'),
                        cancelText: this.$t('异常查看'),
                        onCancel: () => {
                            searchFun();
                        },
                        onOk: () => {
                            // this.gridApi.deselectAll();
                            // selection = this.block.tableData.filter((item) => !item.errorMessage);
                            setTimeout(() => {
                                if (selection.length === 0) {
                                    this.$Modal.warning({
                                        content: this.$t('没有可创建的数据'),
                                    });
                                } else {
                                    comfirm();
                                }
                            }, 400);
                        },
                    })
                } else {
                    comfirm();
                }
            }
            
            // let ids = this.block.selection.map(i => i.poLineId);
            // // this.rowsTableData.forEach((item, index, arr) => {
            // //     if(ids.includes(item.poLineId)) {
            // //         arr.splice(index, 1);
            // //     }
            // // });
        },

        validRow() {
            let tag = true;
            ['orgCode', 'etd', 'eta'].forEach((i) => {
                this.$refs.formItemRef.validateField(i, (vad) => {
                    if (vad) {
                        tag = false;
                    }
                });
            })
            if (this.uploadFiles.length === 0) {
                this.showTips(this.$t('importNoticeCommon.t77')); // 通知书附件不能为空
                tag = false;
            }
            return tag;
        },
        /** 保存 */
        handlSave(oob = 'save', lines = null) {
            if (!this.validRow()) {
                return false;
            }
            let params = {};
            let paramsAll = {};
            let obj = this.orgList.find(item => item.value === this.formItem.orgCode);
            if (obj && obj.label) {
                params.orgName = obj.label;
                params.erpOrgId = obj.erpOrgId;
            }
            for (const k in this.formItem) {
                if (this.formItem.hasOwnProperty(k)) {
                    const val = this.formItem[k];
                    if (k !== 'creationDate') {
                        params[k] = val;
                    }
                    if (k === 'etd' || k === 'eta') {
                        params[k] = val ? moment(val).format('YYYY-MM-DD 00:00:00') : '';
                    }
                }
            }
            if (this.isNew) {
                // params.annexId = this.uploadFiles[0].annexId, // "附件ID",
                // params.annexName = this.uploadFiles[0].annexName, // "附件名称",
                // params.creationDate = '', // 创建时间
                params.createdBy = JSON.parse(window.localStorage.user).loginName // "当前登录帐号"
                paramsAll.annexes = [...this.uploadFiles];
            }
            if (this.headerId) { // 更新
                params = {};
                params = {...this.formItem};
                params.etd = params.etd ? moment(params.etd).format('YYYY-MM-DD 00:00:00') : '';
                params.eta = params.eta ? moment(params.eta).format('YYYY-MM-DD 00:00:00') : '';
                params.remarks = this.formItem.remarks; // "备注",
            }
            paramsAll.header = {...params};
            // this.rowsTableData.forEach(item => {
            //     item.attribute3 = item.tradingMode || '';
            // });
            // paramsAll.lines = [...this.rowsTableData];
            paramsAll.lines = oob === 'save' ? lines : [...this.rowsTableData];
            return new Promise((resolve, reject) => {
                let url = this.headerId ? '/gscint/imptNotyHeader/headerUpdate' : '/gscint/imptNotyHeader/headerAdd';
                /* 弹窗新增行调用新接口 */
                if (lines && this.headerId) {
                    url = '/gscint/imptNotyLine/lineAdd';
                    paramsAll = {
                        header: {
                            headerId: this.headerId
                        },
                        lines,
                    }
                }
                paramsAll.lines.forEach((item) => {
                    /* 按发票创建特殊处理 */
                    if (!this.isPoType) {
                        item.dealQuantity = item.transactionQuantity || item.dealQuantity;
                    }
                    /* 新增来源字段，区分按发票还是按订单创建 */
                    item.source = this.createType.toUpperCase();
                    /* 行数据去掉品牌、产地字段前后空格 */
                    item.brand = (item.brand || '').trim();
                    item.origin = (item.origin || '').trim();
                });
                paramsAll.lines = paramsAll.lines.map(({ tempLineNumber, tempSessionId, dealQuantity, itemNetWeight, supplierInvoiceDate, supplierInvoiceItemNumber, source, ctn, brand, origin, grossWeight }) => {
                            return {
                                tempLineNumber,
                                tempSessionId,
                                dealQuantity,
                                itemNetWeight,
                                supplierInvoiceDate,
                                supplierInvoiceItemNumber,
                                source,
                                ctn,
                                brand,
                                origin,
                                grossWeight,
                            };
                        });
                this.loading = true;
                axios.post(url, paramsAll).then(res => {
                    this.loading = false;
                    let rep = res.data;
                    if (rep.data.success === true) {
                        if (oob === 'save') { // 保存
                            if (this.headerId) {
                                this.getImptNotyHeader().then(() => {
                                    this.getImptNotyLine();
                                    this.getFileList();
                                })
                                this.$Modal.success({
                                    content: this.$t('common.save_success'), // 保存成功
                                });
                            } else {
                                this.headerId = rep.data.data.headerId;
                                this.formItem.imptNumber = rep.data.data.imptNumber;
                                this.$Modal.success({
                                    content: this.$t('common.save_success') // 保存成功
                                });
                                // this.goBack();
                                this.$closeTab({
                                    name: 'importNoticeAdd'
                                });
                                this.$nextTick(() => {
                                    this.$router.push({
                                        name: 'importNoticeEdit',
                                        query: {
                                            headerId: this.headerId
                                        }
                                    });
                                })
                            }
                        } else { // 提交
                            if (!this.headerId) {
                                this.headerId = rep.data.data.headerId;
                            }
                            resolve();
                        }
                    } else {
                        this.showTips(rep.data.message);
                    }
                    reject();
                }).catch(err => {
                    reject();
                    this.loading = false;
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1'),
                        error: err.stack.toString()
                    });
                });
            });
        },
        /** 提交 */
        handleSubmit() {
            this.$Modal.confirm({
                content: this.$t('importNoticeCommon.t161'), // 检查发票数据和进口通知书是否一致再提交。确认提交？
                onOk: () => {
                    this.handlSave('submit').then(() => {
                        this.loading = false;
                        this.submitImportNotice();
                    });
                },
            });
        },
        submitImportNotice() {
            let params = {};
            params.headerId = this.headerId;
            params.imptStatus = 'SUBMITTED';
            this.loading = true;
            axios.post('/gscint/imptNotyHeader/headerUpdate', {header: {...params}}).then(res => {
                this.loading = false;
                let rep = res.data;
                if (rep.data.success) {
                    this.$Modal.success({
                        content: rep.data.message,
                        onOk: () => {
                            this.goBack();
                        }
                    });
                } else {
                    this.showTips(rep.data.message);
                }
            }).catch(err => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1'),
                    error: err.stack.toString()
                });
            });
        },
        onChangeOrgCode(val) {
            this.orgList.map((item) => {
                if (item.value === val) {
                    this.formItem.orgCode = item.value;
                    this.formItem.orgName = item.label;
                    this.formItem.erpOrgId = item.erpOrgId;
                }
            });
        },
        onChangeEtd(date) {
            this.formItem.etd = date;
            let start = moment(date).startOf('day')._d;
            let end = moment(this.formItem.eta).startOf('day')._d;
            if (new Date(start).getTime() > new Date(end).getTime()) {
                this.showTips(this.$t('importNoticeCommon.t89')); // 预计发船日期不能晚于预计到港日期
                this.$nextTick(() => {
                    this.formItem.eta = '';
                })
            }
        },
        onChangeEta(date) {
            this.formItem.eta = date;
            let start = moment(this.formItem.etd).startOf('day')._d;
            let end = moment(date).startOf('day')._d;
            if (new Date(start).getTime() > new Date(end).getTime()) {
                this.showTips(this.$t('importNoticeCommon.t89')); // 预计发船日期不能晚于预计到港日期
                this.$nextTick(() => {
                    this.formItem.eta = '';
                })
            }
        },
        /** 添加 */
        handleAdd(type) {
            if (!this.validRow()) {
                return false;
            }
            this.createType = type;
            this.block.modal = true;
            this.block.selection = [];
            this.block.tableData = [];
            this.getFormDataItemObj(this.block.formData.items, 'tradingMode').values = this.formItem.tradingMode;
        },
        beforeUpload(file) {
            console.log('beforeUpload::', file);
            if (file.size > 62914560) {
                this.$Message.warning({
                    title: this.$t('common.warn'),
                    content: this.$t('importNoticeCommon.t79') // 文件大小不能超过60M！
                });
                return false;
            }
        },
        uploadProgress(event, file, fileList) {
            this.uploadLoading = true;
        },
        uploadSuccess(response, file, fileList) {
            console.log('response::', response);
            this.uploadLoading = false;
            if (response.success === true) {
                this.uploadFiles.push({
                    annexId: response.data.docId,
                    annexName: response.data.fileName
                });
                if (this.headerId) {
                    this.addFile(response.data.docId, response.data.fileName);
                } else {
                    this.$Modal.success({
                        title: this.$t('common.warn'),
                        content: this.$t('common.upload_success') // 上传成功
                    });
                }
            } else {
                this.showTips(this.$t('common.upload_error')); // 上传失败
                this.$refs['upload1'].clearFiles();
            }
        },
        fileUpload(file) {
            console.log('``````fileUpload``````::', file);
        },
        failUpload() {
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.upload_error') // 附件上传失败，请重新上传！
            });
            this.$refs.uploadFileRef.clearFiles();
        },
        onFormatError() {
            this.uploadLoading = false;
            this.$Modal.error({
                content: this.$t('importNoticeCommon.t31') // `附件只支持${this.fileTypeList.join()}格式`
            });
        },
        removeFile(file, fileList) {
            console.log('removeFile:', file, fileList);
        },
        downloadFile2(docId) {
            window.open(`/gscint/supplierfile/downloadFile?docId=${docId}`);
        },
        downloadCustomFile(annexUrl) {
            window.open(annexUrl);
        },
        addFile(docId, fileName) {
            let params = {};
            params.annexId = docId; // 附件ID
            params.annexName = fileName; // 附件名称
            params.imptNumber = this.formItem.imptNumber; // 进口通知单号
            // params.notyHeaderId = this.headerId;
            this.loading = true;
            axios.post('/gscint/notyAnnex/annexAdd', params).then(res => {
                this.loading = false;
                let rep = res.data;
                if (rep.data.success) {
                    this.$Modal.success({
                        title: this.$t('common.warn'),
                        content: rep.data.message
                    });
                } else {
                    this.showTips(rep.data.message);
                }
            }).catch(err => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1'),
                    error: err.stack.toString()
                });
            });
        },
        deleteFile(annexId) {
            if (!annexId) {
                return false;
            }
            if (this.headerId) {
                if (this.uploadFiles.length === 1) {
                    this.showTips(this.$t('importNoticeCommon.t29'));
                    return false;
                }
                this.loading = true;
                axios.get('/gscint/notyAnnex/annexDel', {
                    params: { annexId }
                }).then(res => {
                    this.loading = false;
                    let rep = res.data;
                    if (rep.data.success) {
                        this.$Modal.success({
                            title: this.$t('common.warn'),
                            content: rep.data.message
                        });
                        this.uploadFiles.forEach((item, index, arr) => {
                            if (item.annexId === annexId) {
                                arr.splice(index, 1);
                            }
                        });
                        // console.log('deleteFile__this.uploadFiles::', this.uploadFiles);
                    } else {
                        this.showTips(rep.data.message);
                    }
                }).catch(err => {
                    this.loading = false;
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1'),
                        error: err.stack.toString()
                    });
                });
            } else {
                this.uploadFiles.forEach((item, index, arr) => {
                    if (item.annexId === annexId) {
                        arr.splice(index, 1);
                    }
                });
            }
        },
        /** 全部导出 */
        handleExport() {
            this.loading = true;
            axios.post('/gscint/imptNotyLine/exportLineList', {
                headerId: this.headerId,
                language: this.$i18n.locale,
            }, {
                responseType: 'blob',
                headers: { 
                    'Content-Type': 'application/json;charset=UTF-8' 
                }
            })
            .then((res) => {
                this.loading = false;
                this.downloadFile(res.data, 'ImportNotification.xlsx');
            })
            .catch(() => {
                this.showErrorTips();
            });
        },

        /** 导入 */
        uploadCancel() {
            this.current1 = 0;
        },
        uploadComplete() {
            this.current1 = 0;
            this.uploadModal = false;
        },
        prev() {
            this.current1--;
            var bar = document.querySelector('#step-bar-active');
                bar.style.width = this.current1 * 125 + 'px';
        },
        next() {
            if (this.current1 === 0) {
                this.current1++;
                var bar = document.querySelector('#step-bar-active');
                bar.style.width = this.current1 * 125 + 'px';
            }
        },
        importBeforeUpload (file) {
            let name = this.createType === 'po' ? this.$t('importNoticeCommon.h6') : this.$t('importNoticeCommon.h5');
            if (file.name.indexOf(name) === -1) {
                this.$Modal.error({
                    content: this.$t('importNoticeCommon.t113')
                });
                return false;
            }
        },
        uploadProgress2() {
            this.uploadFileLoading = true;
        },
        uploadSuccess2(res) {
            /* 是否按订单创建类型 */
            let isPo = this.createType === 'po';
            this.excelImportTips = '';
            if (res.success) {
                if (res.data.code !== 20000 && res.data.code !== '1') {
                    this.$Modal.error({
                        content: isPo ? res.data.message : res.data.msg
                    });
                    this.uploadFileLoading = false;
                    this.$refs['upload1'].clearFiles();
                    return false;
                }
                let list = isPo ? res.data.data.rows : res.data.datas;
                list.forEach((item, index) => {
                    // if (item.poLineNumber) {
                    //     item.poLineNumber = Number(item.poLineNumber);
                    // }
                    /* 前端生成唯一ID */
                    item.uuId = String(item.index || item.idx);
                    console.log('item.uuId', item.uuId, index);
                });
                /* 按发票号生成，需要合并导入数据和界面数据求交集 */
                if (this.block.tableData.length === list.length) {
                    this.block.tableData.forEach((item) => {
                        let importIndex = list.findIndex((i) => i.uuId === item.uuId);
                        list[importIndex] = {
                            ...item,
                            ...list[importIndex]
                        }
                    });
                } else {
                    this.$Modal.error({
                        content: this.$t('importNoticeCommon.t136')
                    });
                    return false;
                }
                // 把添加明细筛选贸易方式写入添加明细行
                let tradingModeTemp = this.getFormDataItemObj(this.block.formData.items, 'tradingMode').value
                list.forEach(item => {
                    item.tradingMode = tradingModeTemp;
                });
                // if (list.find(b => !b.poNumber || !b.poLineNumber)) {
                //     debugger;
                //     this.excelImportTips = this.$t('importNoticeCommon.t50') + ',' + this.$t('importNoticeCommon.t51') + ' ' + this.$t('importNoticeCommon.t3') + ',' + this.$t('importNoticeCommon.t95') // PO号,PO行号不能为空,请检查
                //     this.current1++;
                //     var bar = document.querySelector('#step-bar-active');
                //         bar.style.width = this.current1 * 125 + 'px';
                //     this.uploadFileLoading = false;
                //     return false;
                // }
                let iArr = list.filter(a => a.poNumber && a.poLineNumber);
                let msg1 = [], msg2 = [], msg3 = [], msg4 = [];

                /** iv.	如果‘PO号’+‘PO行号’不在系统中，则提示：不存在**PO号，请检查，英文为（No *** PO number , please check.） */
                let cAll = this.block.tableData.map(c => {
                    if (c.poNumber && c.poLineNumber) {
                        return '' + c.poNumber + c.poLineNumber;
                    }
                });
                /** iii.	成交数量、原产地、总净重、发票号、发票项号、发票日期，不可为空 */
                let poIds = [];
                console.log('iArr', iArr);
                iArr.forEach((i) => {
                    let temp = '' + i.poNumber + i.poLineNumber;
                    if (!cAll.includes(temp)) {
                        /* 不存在xxx PO号，请检查 */
                        msg1.push(this.$t('importNoticeCommon.t96') + `[${oi.poNumber}]` + this.$t('importNoticeCommon.t97') + ', ' + this.$t('importNoticeCommon.t95') + '</br>');
                    }
                    // msg3.push(`[${i.poNumber}]` + 'PO号的' + `[${i.poLineNumber}】行号的`)
                    let dQty = i.dealQuantity;
                    let iWgt = i.itemNetWeight;
                    let dQtyMaxVal = Number(i.unfinishedQuantiey);
                    let tpmsg3 = [];
                    let tpmsg4 = [];
                    /* 不同类型，成交数量用不一样的字段 */
                    if (this.isPoType) {
                        if (!i.dealQuantity) { // 成交数量
                            tpmsg3.push(this.$t('importNoticeCommon.t41'));
                        }
                    } else {
                        if (!i.transactionQuantity) { // 成交数量
                            tpmsg3.push(this.$t('importNoticeCommon.t41'));
                        }
                    }
                    if (!i.origin) { // 原产地
                        tpmsg3.push(' ,' + this.$t('importNoticeCommon.t42'));
                    }
                    if (!i.itemNetWeight) { // 总净重
                        tpmsg3.push(' ,' + this.$t('importNoticeCommon.t43'));
                    }
                    if (!i.supplierInvoiceNumber) { // 发票号  
                        tpmsg3.push(' ,' + this.$t('importNoticeCommon.t44'));
                    }
                    // if (!i.supplierInvoiceItemNumber && this.createType === 'po') { // 发票项号 （按发票类型创建，发票号不校验）
                    //     tpmsg3.push(' ,' + this.$t('importNoticeCommon.t82'));
                    // }
                    if (!i.supplierInvoiceDate) { // 发票日期
                        tpmsg3.push(' ,' + this.$t('importNoticeCommon.t45'));
                    }
                    if (tpmsg3.length > 0) {
                        tpmsg3.unshift(this.$t('importNoticeCommon.t90') + `[${i.poNumber}]` + this.$t('importNoticeCommon.t91') + `[${i.poLineNumber}]` + this.$t('importNoticeCommon.t93') +' ');
                        tpmsg3.push(' ' + this.$t('importNoticeCommon.t94') + '</br>'); // 字段为空，请检查</br>
                        msg3.push(tpmsg3.join());
                    } else {
                        poIds.push(`${i.poLineNumber}${i.poNumber}`);
                    }
                    if (dQty) { // 成交数量
                        // if (isNaN(dQty) || dQty <= 0) {
                        //     msg4.push(this.$t('importNoticeCommon.t68')); // 成交数量不允许小于等于0
                        //     msg4.push(',' + this.$t('importNoticeCommon.t95') + '</br>'); // 请检查
                        // }
                        if (isNaN(dQty) || dQty <= 0) {
                            tpmsg4.push(this.$t('importNoticeCommon.t41') + this.$t('importNoticeCommon.t68')); // 成交数量不允许小于等于0
                            tpmsg4.push(', ' + this.$t('importNoticeCommon.t95') + '</br>'); // 请检查
                        }
                        if (dQty > dQtyMaxVal && isPo) {
                            tpmsg4.push(this.$t('importNoticeCommon.t70') + dQtyMaxVal); // `成交数量不允许超过${dQtyMaxVal}`
                            tpmsg4.push(', ' + this.$t('importNoticeCommon.t95') + '</br>'); // 请检查
                        }
                        // /* 发票类型校验 
                        //    商业发票数量 < 订单的未完成数量 自动带成交数量，数量为‘商业发票数量’
                        // */
                        // if (t.unfinishedQuantiey || t.unfinishedQuantiey === 0) {
                        //     if (Number(t.unfinishedQuantiey) < Number(t.dealQuantity)) {
                        //         t.dealQuantity = '';
                        //         tpmsg4.push(this.$t('importNoticeCommon.t116')+ '</br>');
                        //     }
                        // }
                    }
                    if (iWgt) { // 总净重
                        if (isNaN(iWgt) || iWgt <= 0) {
                            tpmsg4.push(this.$t('importNoticeCommon.t43') + this.$t('importNoticeCommon.t83')); // 总净重不允许小于等于0
                            tpmsg4.push(', ' + this.$t('importNoticeCommon.t95') + '</br>'); // 请检查
                        }
                    }
                    if (tpmsg4.length > 0) {
                        try{
                            tpmsg4.unshift(this.$t('importNoticeCommon.t90') + `[${i.poNumber}]` + this.$t('importNoticeCommon.t91') + `[${i.poLineNumber}]` + this.$t('importNoticeCommon.t93') +' ');
                            msg4 = msg4.concat(tpmsg4);
                        } catch (err) {
                            console.log(err);
                        }
                    }
                });
                console.log('msg3::', msg3);

                let showMsg = '';
                if (msg1.length > 0 || msg2.length > 0 ||  msg3.length > 0 || msg4.length > 0) {
                    if (msg1.length > 0 || msg2.length > 0) {
                        [msg1, msg2].map(u => u.push('</br>'));
                        msg2 = msg1.concat(msg2);
                        showMsg = msg2;
                    } else if (msg3.length > 0 || msg4.length > 0) {
                        [msg3, msg4].map(u => u.push('</br>'));
                        msg3 = msg3.concat(msg4);
                        showMsg = msg3;
                    }
                    this.excelImportTips = this.$t('importNoticeCommon.t101') + `： </br> ${showMsg.join('')}`; // 本次导入验证失败
                } else {
                    iArr = iArr.filter(el => el.poNumber && el.poLineNumber);
                    // 以导入文档的为准不用计算
                    this.importLock = true;
                }
                const newData = JSON.parse(JSON.stringify(this.block.tableData));
                newData.forEach((item, index) => {
                    try {
                        let {dealQuantity, origin, itemNetWeight, supplierInvoiceItemNumber, supplierInvoiceDate, ctn, brand, supplierInvoiceNumber, grossWeight} = iArr.find((i) => i.uuId === item.uuId);
                        item.dealQuantity = dealQuantity; // 成交数量
                        item.origin = origin; // 原产地
                        item.itemNetWeight = itemNetWeight; // 总净重
                        item.supplierInvoiceItemNumber = supplierInvoiceItemNumber; //发票项号
                        item.supplierInvoiceDate = supplierInvoiceDate; // 发票日期
                        item.ctn = ctn; // 箱号
                        item.brand = brand; // 品牌
                        item.grossWeight = grossWeight; // 毛重
                        if (!isPo) {
                            item.supplierInvoiceNumber = supplierInvoiceNumber;          // 发票号
                        }
                    } catch (err) {
                        console.log(err, index);
                    }
                });
                this.block.tableData = newData;
                this.current1++;
                var bar = document.querySelector('#step-bar-active');
                    bar.style.width = this.current1 * 125 + 'px';
            } else {
                this.showTips(res.msg);
                this.$refs['upload1'].clearFiles();
            }
            this.uploadFileLoading = false;
        },
        uploadError2() { // error, file, fileList
            this.uploadFileLoading = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.upload_error') // 附件上传失败，请重新上传！
            });
        },
        onFormatError2() {
            this.uploadFileLoading = false;
            this.$Modal.error({
                content: this.$t('importNoticeCommon.t103') // 只能上传 xls, xlsx 格式文件，文件大小不能超过 60M
            });
        },
        exportAndImportTemplate() {
            let mbDocId = window.environment.isPro ? '184997e31537d247324fdcc4637bd9bd' : '1849979d7b49c1c07e1e5424364be2ca';
            let params = {
                docId: mbDocId,
                lines: this.block.tableData
            }
            /* 是否按采购订单创建 */
            if (this.createType === 'po') {
                let url = '/gscint/imptNotyExcel/excelExport';
                axios.post(url, params, {responseType: 'arraybuffer'}).then(res => {
                    let url = window.URL.createObjectURL(new Blob([res.data])); 
                    let link = document.createElement('a');
                    link.style.display = "none";
                    link.setAttribute('href', url);
                    link.setAttribute('download', `${this.$t('importNoticeCommon.h6')}.xlsx`);  
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(() => {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                });
            } else {
                if (this.block.tableData.length === 0) {
                    this.$Modal.error({
                        content: this.$t('importNoticeCommon.t112') // 没有可导出的数据
                    })
                    return false;
                }
                this.loading = true;
                let poLineIds = [];
                this.rowsTableData.forEach((item) => {
                    poLineIds.push(item.poLineId);
                });
                poLineIds = poLineIds.join();
                axios.post('/gscint/imptNotyHeader/exportInvoiceNo', {
                    vendorCode: this.vendorCode,
                    invoiceNo: this.block.tableData[0].supplierInvoiceNumber,
                    poLineIds,
                    headerId: this.headerId ? this.headerId : undefined,
                    ...this.getFormDataVModel(this.block.formData2.items),
                    orgCode: this.formItem.orgCode,
                    tempSessionId: this.block.tableData[0].tempSessionId,
                    language: this.$i18n.locale,
                }, {
                    responseType: 'blob',
                    headers: { 
                        'Content-Type': 'application/json;charset=UTF-8' 
                    }
                })
                .then((res) => {
                    this.loading = false;
                    this.downloadFile(res.data, `${this.$t('importNoticeCommon.h5')}.xlsx`);
                })
                .catch(() => {
                    this.showErrorTips();
                });
            }
        },
        // 导入end

        /** 验证正整数 */
        // validatePositive(val) {
        //     var rel = /^[0-9]*[1-9][0-9]*$/;
        //     return rel.test(val);
        // },
        numSub(n1, n2) {
            let sum, m1, m2;
            let precision; // 精度
            try {
                m1 = n1.toString().split('.')[1].length;
            } catch (e) {
                m1 = 0;
            }
            try {
                m2 = n2.toString().split('.')[1].length;
            } catch (e) {
                m2 = 0;
            }
            sum = Math.pow(10, Math.max(m1, m2));
            precision = (m1 >= m2) ? m1 : m2;
            return parseFloat(((n1 * sum - n2 * sum) / sum).toFixed(precision));
        },
        getImptNotyHeader() {
            return new Promise(resolve => {
                this.loading = true;
                this.formItem = {};
                this.uploadFiles = [];
                this.customsFiles = [];
                axios.post('/gscint/imptNotyHeader/headerList', {
                    headerId: this.headerId,
                    page: this.settings.currentPage,
                    pageSize: this.settings.pageSize
                }).then(res => {
                    this.loading = false;
                    let rep = res.data;
                    if (rep.data.success === true) {
                        let data = rep.data.data.rows;
                        if (data.length > 0) {
                            let objData = data[0] ? data[0] : {};
                            this.formItem = JSON.parse(JSON.stringify(objData));
                            this.uploadFiles = objData.annexes ? objData.annexes : ''; // 通知书附件
                            if (this.onlyRead) {
                                this.formItem.customsNumber = objData.customsNumber ? objData.customsNumber : ''; // 报关单号
                            }
                            this.readDisabled = this.onlyRead && !(this.formItem.imptStatus === 'SUBMITTED' || this.formItem.imptStatus === 'SUPPLEMENT' || this.formItem.imptStatus === 'ARRIVED');
                            this.syncBsShow = ['DRAFT', 'REJECTED', 'REJECT'].includes(objData.imptStatus);
                        }
                        resolve();
                    } else {
                        this.showTips(rep.data.message);
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                });
            });
        },
        /** 获取头的行数据 */
        getImptNotyLine() {
            this.rowsTableData = [];
            // this.showRowsTableData = [];
            this.loading = true;
            let {currentPage, pageSize} = this.settings;
            axios.post('/gscint/imptNotyLine/lineList', {
                headerId: this.headerId,
                ...this.getFormDataVModel(this.mainLineQuery.formData.items),
                page: currentPage,
                pageSize
            })
            .then((res) => {
                this.loading = false;
                let {code, data, message} = res.data.data;
                if (code === 20000) {
                    data.page.list.forEach((item) => {
                        item.totalPrice = (item.dealUnitPrice * item.dealQuantity).toFixed(2);
                        item.tradingMode = item.tradingMode || (item.attribute3 ? item.attribute3 : '');
                    });
                    this.rowsTableData = data.page.list;
                    this.settings.pageTotal = data.page.total;
                    this.lineQtyTotal = data.sum.sumDealQuantity;
                    this.lineWeightTotal = data.sum.sumItemNetWeight;
                    this.selection = [];
                } else {
                    this.showTips(message);
                }
            })
            .catch(() => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        // 获取进口通知书附件
        getFileList() {
            this.loading = true;
            axios.get('/gscint/notyAnnex/annexList', {
                params: {
                    imptNumber: this.formItem.imptNumber // 进口通知单号
                }
            }).then(res => {
                this.loading = false;
                let rep = res.data;
                if (rep.data.success === true) {
                    let data = rep.data.data.rows;
                    let list = [];
                    let list2 = [];
                    data.map((item) => {
                        if (item.annexSource === 'GSC') {
                            let obj = {
                                annexId: item.annexId,
                                annexName: item.annexName
                            }
                            list.push(obj);
                        } else { // IMES为报关附件
                            let obj2 = {
                                annexId: item.annexId,
                                annexName: item.annexName,
                                annexUrl: item.annexUrl
                            }
                            list2.push(obj2);
                        }
                    })
                    this.uploadFiles = list;
                    this.customsFiles = list2;
                } else {
                    this.showTips(rep.data.message);
                }
            }).catch(err => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1'),
                    error: err.stack.toString()
                });
            });
        },
        init() {
            if (this.isNew) {
                this.handleConfirmReset();
                this.rowsTableData = [];
                this.uploadFiles = [];
                this.customsFiles = []; // 报关附件
                this.formItem.imptStatus = 'DRAFT';
                this.formItem.creationDate = moment(new Date()).format('YYYY-MM-DD');
            } else if (this.isEdit || this.onlyRead) {
                this.headerId = this.$route.query.headerId;
                if (this.headerId) {
                    this.getImptNotyHeader().then(() => {
                        this.getImptNotyLine();
                        this.getFileList();
                    })
                }
            }
        },
        queryDictionaryDataDirect (dictCode) {
            axios.get(`/gscint/sys/sysParam/queryDictionaryData?dictCode=${dictCode}`)
            .then((res) => {
                this[dictCode] = res.data.data;
            });
        },
        /* 更新数据选中状态 */
        dataCheckedUpdate () {
            this.$nextTick(() => {
                let table = this.$refs.pageForm.$refs.iTable.$refs.iTable;
                let newTableData = this.objDeepCopy(table.objData);
                for (let i in newTableData) {
                    /* 不存在poLineId数据不可操作 */
                    if (!newTableData[i].poLineId) {
                        newTableData[i]._isDisabled = true;
                    } else {
                        let tableItem = newTableData[i];
                        if (this.block.selection.find(({uuId}) => uuId === tableItem.uuId)) {
                            newTableData[i]._isChecked = true;
                        } else {
                            newTableData[i]._isChecked = false;
                        }
                    }
                }
                table.objData = newTableData;
            });
        },
        /* 同步保税属性 */
        refreshBondedTradeType () {
            this.loading = true;
            axios.get('/gscint/imptNotyLine/refreshBondedTradeType', {
                params: {
                    headerId: this.headerId
                }
            })
            .then((res) => {
                this.loading = false;
                if (res.data.data.success) {
                    this.getImptNotyLine();
                }
            })
            .catch(() => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        /** 深拷贝 */
        objDeepCopy(source) {
            var sourceCopy = source instanceof Array ? [] : {};
            for (var item in source) {
                if (typeof source[item] === 'object') {
                    if (source[item] === null) {
                        sourceCopy[item] = null;
                    } else {
                        sourceCopy[item] = this.objDeepCopy(source[item]);
                    }
                } else {
                    sourceCopy[item] = source[item];
                }
            }
            return sourceCopy;
        },
        // blockDataHandle2 (page, pageSize) {
        //     this.settings.currentPage = page;
        //     this.settings.pageSize = pageSize;
        //     this.settings.pageTotal = this.rowsTableData.length;
        //     let data = this.objDeepCopy(this.rowsTableData);
        //     this.showRowsTableData = data.slice((page - 1) * pageSize, pageSize * page);
        // },
        /** 当前页改变时触发 */
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.getImptNotyLine();
        },
        /** 页容量改变时触发 */
        onPageSizeChange(pageSize) {
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.getImptNotyLine();
        },
        /* 发票查询 */
        async queryInvoiceNoList () {
            this.invoiceNoModal.loading = true;
            await axios.post('/gscint/imptNotyHeader/queryInvoiceNoList', {
                vendorCode: this.vendorCode,
                orgCode: this.formItem.orgCode
            })
            .then((res) => {
                let data = res.data.data.datas || [];
                let list = [];
                data.forEach((invoiceNo) => {
                    list.push({
                        invoiceNo
                    });
                });
                this.invoiceNoModal.backUpData = list;
                this.invoiceNoModal.data = this.objDeepCopy(list);
            })
            .catch(() => {
                this.showErrorTips();
            });
            this.invoiceNoModal.loading = false;
        },
        /* 发票号选择 */
        invoiceOnClick ({invoiceNo}) {
            this.invoiceNoModal.show = false;
            this.getFormDataItemObj(this.block.formData.items, 'invoiceNo').value = invoiceNo;
        },
        /* 发票号过滤 */
        invoiceFilter () {
            let list = this.objDeepCopy(this.invoiceNoModal.backUpData);
            this.invoiceNoModal.data = list.filter((item) => item.invoiceNo.indexOf(this.invoiceKeyWord) > -1);
        },
        /* 拆分品牌查询 */
        splitBrandOnSubmit () {
            this.splitBrandModal.loading = true;
            axios.post('/gscint/purImptNotyDetailI/detailList', {
                headerId: this.headerId,
                ...this.getFormDataVModel(this.splitBrandModal.formData.items)
            })
            .then((res) => {
                this.splitBrandModal.loading = false;
                let {code, data, message} = res.data.data;
                if (code === 20000) {
                    let lineIds = [];
                    data.list.forEach(({lineId}) => {
                        if (!lineIds.includes(lineId)) {
                            lineIds.push(lineId);
                        }
                    });
                    this.splitBrandModal.lineIds = lineIds;
                    this.splitBrandModal.tableData = data.list;
                    this.splitBrandModal.settings.pageTotal = data.list.length;
                    this.splitBrandModal.selection = [];
                } else {
                    this.$Modal.error({
                        content: message
                    });
                }
            })
            .catch(() => {
                this.splitBrandModal.loading = false;
                this.showErrorTips();
            })
        },
        splitBrandModalSelect (lineId, flag) {
            let table = this.$refs.pageForm2.$refs.iTable.$refs.iTable.objData;
            for (let i in table) {
                if (table[i].lineId === lineId) {
                    table[i]._isChecked = flag;
                }
            }
        },
        splitBrandOnCancel (selection, {lineId}) {
            this.splitBrandModalSelect(lineId, false);
        },
        splitBrandOnSelect (selection, {lineId}) {
            this.splitBrandModalSelect(lineId, true);
        },
        splitBrandOnSelectionChange () {
            const table = this.$refs.pageForm2.$refs.iTable.$refs.iTable.objData;
            let newSelection = [];
            const filterLineIds = [];
            const checkLineIds = [];
            for (let i in table) {
                const item = table[i];
                if (item._isChecked) {
                    checkLineIds.push(item.lineId);
                }
                filterLineIds.push(item.lineId);
            }
            newSelection = this.splitBrandModal.tableData.filter((item) => checkLineIds.includes(item.lineId));
            this.splitBrandModal.selection = this.splitBrandModal.selection.filter((item) => !filterLineIds.includes(item.lineId)).concat(newSelection);
            if (this.splitBrandModal.selection.length !== this.splitBrandModal.tableData.length) {
                this.splitBrandModal.selectAllFlag = false;
            }
        },
        rowClassName(row, index) {
            let rowClass;
            this.splitBrandModal.lineIds.forEach((item, index) => {
                if (row.lineId === item) {
                    if (index % 2 === 0) {
                        rowClass = 'gray';
                    } else {
                        rowClass = '';
                    }
                }
            });
            return rowClass;
        },
        /* 拆分品牌校验 */
        splitBrandValidate ({lineId, dealQuantity}) {
            let list = this.splitBrandModal.tableData.filter((item) => item.lineId === lineId);
            let totalQty = 0;
            let noQtyList = [];
            let tips = '';
            list.forEach((item) => {
                if (item.detailDealQuantity) {
                    totalQty += +item.detailDealQuantity;
                } else {
                    noQtyList.push(item.detailLineId);
                }
            });
            if (noQtyList.length === 0) {
                if (+dealQuantity !== totalQty) {
                    // 成交数量与拆分前的成交数量不一致，请检查
                    tips = this.$t('importNoticeCommon.t132');
                }
            } else {
                if (noQtyList.length === 1) {
                    const num = +dealQuantity - totalQty;
                    if (num < 0) {
                        // 成交数量与拆分前的成交数量不一致，请检查
                        tips = this.$t('importNoticeCommon.t132');
                    } else {
                        // this.splitBrandModal.tableData[this.splitBrandModal.tableData.findIndex((item) => item.detailLineId === noQtyList[0])].detailDealQuantity = num;
                        this.$set(this.splitBrandModal.tableData[this.splitBrandModal.tableData.findIndex((item) => item.detailLineId === noQtyList[0])], 'detailDealQuantity', num);
                    }
                }
            }
            if (tips) {
                this.$Modal.warning({
                    content: tips
                });
            }
        },
        /* 拆分品牌保存 */
        splitBrandSave (button) {
            console.log(this.splitBrandModal.selection);
            let selection = this.$refs.pageForm2.$refs.iTable.$refs.iTable.getSelection();
            let tips = [];
            let lines = {}
            let postLine = [];
            selection.forEach((item, index) => {
                ['detailDealQuantity', 'detailItemNetWeight'].forEach((keyName) => {
                    if (!item[keyName] && item[keyName] !== 0) {
                        tips.push(`<p>${this.splitBrandModal.columns.columns.find((col) => col.key === keyName).title}${this.$t('importNoticeCommon.t3')}</p>`)
                    } else {
                        /* 数量累计 */
                        if (keyName === 'detailDealQuantity') {
                            if (!lines[item.lineId]) {
                                lines[item.lineId] = {
                                    detailDealQuantity: Number(item.detailDealQuantity),
                                    dealQuantity: Number(item.dealQuantity)
                                }
                            } else {
                                lines[item.lineId].detailDealQuantity += Number(item.detailDealQuantity);
                            }
                        }
                    }
                });
                let {detailLineId, detailItemNetWeight, detailDealQuantity} = item;
                postLine.push({
                    detailLineId,
                    detailItemNetWeight,
                    detailDealQuantity
                });
            });
            if (tips.length === 0) {
                for (let i in lines) {
                    if (lines[i].dealQuantity !== lines[i].detailDealQuantity) {
                        tips.push(`${this.$t('importNoticeCommon.t132')}`);
                    }
                }
            }
            if (tips.length > 0) {
                this.$Modal.warning({
                    content: Array.from(new Set(tips)).join('')
                });
                return false;
            }
            this.splitBrandModal.loadding = true;
            axios.post('/gscint/purImptNotyDetailI/updateDetails', postLine)
            .then((res) => {
                this.splitBrandModal.loadding = false;
                let {code, message} = res.data.data;
                if (code === 20000) {
                    this.$Modal.success({
                        content: this.$t('common.save_success')
                    });
                    this.splitBrandModal.show = false;
                    this.getImptNotyLine();
                } else {
                    this.$Modal.error({
                        content: message
                    });
                }
            })
            .catch(() => {
                this.splitBrandModal.loadding = true;
                this.showErrorTips();
            })
        },
        deleteInBatchesWarn () {
            this.$Modal.confirm({
                title: this.$t('common.warn'),
                content: this.$t('importNoticeCommon.t23'), // 确定要删除吗？
                onOk: () => {
                    setTimeout(() => {
                        this.deleteInBatches();
                    }, 300);
                }
            });
        },
        // 批量删除
        deleteInBatches () {
            this.loadding = true;
            axios.post(`/gscint/imptNotyLine/lineDelete/${this.headerId}`, this.selection.map((item) => item.detailLineId))
            .then((res) => {
                let {code, message} = res.data.data;
                if (code === 20000) {
                    this.getImptNotyLine();
                } else {
                    this.showErrorTips('loading', message);
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        onSelect (selection) {
            this.selection = selection;
        },
        splitBrandBeforeUpload() {
            this.splitBrandModal.import.loading = true;
        },
        splitBrandOnSuccess(res) {
            this.splitBrandModal.import.loading = false;
            const { code, datas } = res.data;
            if (code === '1') {
                /* 数量不一致 */
                if (datas.length !== this.splitBrandModal.tableData.length) {
                    this.$Modal.warning({
                        content: this.$t('importNoticeCommon.t136'),
                    });
                } else {
                    let tips;
                    this.splitBrandModal.tableData.forEach((item, index) => {
                        const { detailDealQuantity, detailItemNetWeight } = datas[index];
                        if (!this.splitBrandModal.qtyRule.test(detailDealQuantity)) {
                            tips = this.$t('importNoticeCommon.t131');
                        } else {
                            item.detailDealQuantity = detailDealQuantity;
                        }
                        if (!this.splitBrandModal.qtyRule.test(detailItemNetWeight)) {
                            tips = this.$t('importNoticeCommon.t131');
                        } else {
                            item.detailItemNetWeight = detailItemNetWeight;
                        }
                    });
                    if (tips) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: tips,
                        });
                    } else {
                        /* 导入成功 */
                        this.$Modal.success({
                            content: this.$t('importNoticeCommon.t102')
                        });
                        this.splitBrandModal.import.show = false;
                    }
                }
            } else {
                this.$Modal.warning({
                    content: this.$t('importNoticeCommon.t101'),
                });
            }
        },
        splitBrandOnError() {},
        splitBrandOnFormatError() {},
        splitBrandOnOnPageSizeChange(pageNum, pageSize) {
            this.splitBrandModal.settings.currentPage = 1;
            this.splitBrandModal.settings.pageSize = pageSize;
        },
        splitBrandOnPageChange(pageNum, pageSize) {
            this.splitBrandModal.settings.currentPage = pageNum;
        },
        splitselectAllOnChange(flag, click = false) {
            if (click) {
                this.splitBrandModal.selection = flag ? this.objDeepCopy(this.splitBrandModal.tableData) : [];
                this.splitBrandAutoSelect();
            }
        },
        /* 品牌拆分自动选中 */
        splitBrandAutoSelect() {
            this.$nextTick(() => {
                let table = this.$refs.pageForm2.$refs.iTable.$refs.iTable.objData;
                for (let i in table) {
                    table[i]._isChecked = this.splitBrandModal.selection.some((item) => item.lineId === table[i].lineId);
                }
            });
        },
        onMianLineSearch() {
            this.getImptNotyLine();
        },
        /* 一键报关 */
        batchSetCustomerNumber() {
            this.customsNumberModal.loading = true;
            axios.post('/gscint/imptNotyLine/batchSetCustomerNumber', {
                headerId: this.headerId,
                customsNumber: this.customsNumberModal.customsNumber,
            })
                .then((res) => {
                    const { code, message: content } = res.data.data;
                    if (code === 20000) {
                        this.$Modal.success({
                            content: this.$t('common.save_success'),
                        })
                        this.getImptNotyLine();
                        this.customsNumberModal.show = false;
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                })
                .finally(() => {
                    this.customsNumberModal.loading = false;
                });
        },
        /* 更新头行信息 */
        upadteHeaderAndLine() {
            this.getImptNotyHeader();
            this.getImptNotyLine();
        },
        /* 提交报关单号 */
        batchSetImptStatusDeclare(detailLineIds) {
            this.$Modal.confirm({
                content: this.$t('importNoticeCommon.t152'),
                onOk: () => {
                    if (detailLineIds !== 'ALL') {
                        detailLineIds = this.selection.reduce((prev, next) => {
                            return prev += `${next.detailLineId},`;
                        }, '');
                    }
                    this.customsNumberModal.loading = true;
                    axios.post('/gscint/imptNotyLine/batchSetImptStatusDeclare', {
                        headerId: this.headerId,
                        detailLineIds,
                    })
                        .then((res) => {
                            const { code, message: content, data } = res.data.data;
                            if (code === 20000) {
                                this.$Modal.success({
                                    content: this.$t('common.save_success'),
                                })
                                this.customsNumberModal.show = false;
                                this.upadteHeaderAndLine();
                            } else {
                                this.$Modal.warning({
                                    content,
                                });
                            }
                        })
                        .catch(() => {
                            this.showErrorTips();
                        })
                        .finally(() => {
                            this.customsNumberModal.loading = false;
                        });
                },
            });
        },
        /* 撤回 */
        importReject() {
            this.loading = true;
            axios.post('/gscint/imptNotyHeader/headerReject', {
                header: {
                    headerId: this.headerId,
                    imptStatus: 'REJECT',
                    orgCode: this.formItem.orgCode,
                }
            })
                .then((res) => {
                    const { code, message: content, data } = res.data.data;
                    if (code === 20000) {
                        this.$Modal.success({
                            content: this.$t('importNoticeCommon.t151'),
                            onOk: () => {
                                this.goBack();
                            },
                        })
                        this.upadteHeaderAndLine();
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /* 导入报关单excel */
        customsNumberBeforeUpload() {
            this.importCustomsNumberModal.loading = true;
        },
        customsNumberOnSuccess(res) {
            this.importCustomsNumberModal.loading = false;
            const { code, message: content } = res.data;
            if (code === 20001) {
                this.$Modal.warning({
                    content: content.replaceAll('\n', '<br>'),
                });
            } else {
                this.$Modal.success({
                    content,
                });
                this.getImptNotyLine();
                this.importCustomsNumberModal.show = false;
            }
        },
        customsNumberOnError() {
            this.importCustomsNumberModal.loading = false;
            this.showErrorTips();
        },
        customsNumberOnFormatError() {
            this.importCustomsNumberModal.loading = false;
            this.$Modal.error({
                content: this.$t('importNoticeCommon.t103') // 只能上传 xls, xlsx 格式文件，文件大小不能超过 60M
            });
        },
        modalRowClassName({ errorMessage }) {
            return errorMessage ? 'm-table-row-highlight m-table-row-highlight-red' : '';
        },
        setTableUpdate(columns) {
            this.rowsColumns = columns;
        },
        setTableByInvoiceUpdate(columns) {
            this.block.columns.columns = columns;
        },
        setTableByPoUpdate(columns) {
            this.block.columnsByPo.columns = columns;
        },
        onFirstDataRendered(params) {
            this.gridApi = params.api;
        },
        onStateUpdated(params) {
        },
        ViewportChangedEvent(params) {
        },
        /* 数据更新 */
        onRowDataUpdated(params) {
            this.$nextTick(() => {
                console.log(this.gridApi);
                if (this.gridApi) {
                    const nodes = [];
                    this.gridApi.forEachNode((node) => {
                        const data = node.data;
                        if (!this.isPoType) {
                            if (data && data.transactionQuantity && data.itemNetWeight && data.poLineId) {
                                nodes.push(node);
                            }
                            // nodes.push(node);
                        }
                    });
                    this.gridApi.setNodesSelected({ nodes, newValue: true });
                    this.block.selection = this.gridApi.getSelectedRows();
                }
            })
        },
        /* 更新行数据 */
        updateRowData(index, row) {
            this.block.tableData[index] = row;
            this.gridApi.getRowNode(index).setData(row);
            this.block.selection = this.gridApi.getSelectedRows();
        },
        isRowSelectable(rowNode) {
            return !rowNode.data.errorMessage;
        },
    },
    async mounted() {
        this.block.columnsByPo = deepCopy(this.block.columns);
        const {vendorCode, vendorName} = JSON.parse(window.localStorage.supplierInfo);
        this.vendorCode = vendorCode;
        this.vendorName = vendorName;
        this.formItem.vendorCode = this.vendorCode;
        this.formItem.vendorName = this.vendorName;
        /** 单据状态，草稿、已提交、已废弃、已驳回、已补料、已到港、已报关、已放行、已提货、已还柜*/
        this.getDict('INT_IMPT_STATUS', (data) => {
            this.cuxInStatusList = data;
            this.getFormDataItemObj(this.mainLineQuery.formData.items, 'imptStatus').options.values = data;
        });
        /** 订单类型 */
        this.getDict('GSCPOTYPE', (data) => {
            this.getFormDataItemObj(this.block.formData.items, 'poType').options.values = data;
        });
        /** PO贸易方式 */
        this.getDict('INT_BONDED_TYPE', (data) => {
            data.unshift({label: '', value: 'null'});
            this.cuxTradeModeList = data;
            this.getFormDataItemObj(this.block.formData.items, 'tradingMode').options.values = data;
        });
        /** 包装种类 */
        this.getDict('INT_TYPE_OF_PAKAGE', (data) => {
            this.intTypeOfPakageList = data;
            console.log('this.intTypeOfPakageList::', this.intTypeOfPakageList);
        });
        /* 原产地 */
        this.queryDictionaryDataDirect('INT_ORIGIN');
        /*过滤组织*/
        await this.getDict('INT_CUX_DELIVERY_ASSOCIATED_DEC');
        // 获取组织
        this.getSRMInvLovListNew((data) => {
            let list = [];
            /* 过滤组织 */
            let filterOrg = [];
            this.INT_CUX_DELIVERY_ASSOCIATED_DEC.forEach((item) => {
               filterOrg.push(item.code); 
            });
            data.forEach((item) => {
                if (filterOrg.includes(item.organizationCode)) {
                    list.push({
                        label: item.organizationName,
                        value: item.organizationCode,
                        erpOrgId: item.erpOrgId
                    });
                }
            });
            this.orgList = list;
        });
        /* 保税属性字典 */
        this.getDict('INT_BONDED_TYPE');
        if (this._inactive === null && !this.isNew) {
            this.init();
        }
        /* 维护报关组织 */
        this.getDict('INT_CUSTOMS_NO_MODIFY');
        this.getRowId = (params) => params.data.uuId;
    },
    activated() {
        if (!this.isNew) {
            this.init();
        }
    }
};
</script>

<style lang='less' scoped>
    /deep/ .m-card-body {
        padding: 6px;
    }
    /deep/ .import-notice-split-brand-tab {
        .gray {
            td {
                background: #f0f0f0;
            }
        }
    }
    /deep/ .m-table-row-highlight-red {
        .ag-cell-value {
            color: red;
        }
    }
    .qty-total {
        color: red;
        font-size: 14px;
        margin-left: 20px;
    }
</style>
<style lang='less'>
.importNoticeCommon{
    padding: 15px;
    .m-card-body{
        padding: 0px;
    }
    .each-btn {
        margin: 8px 8px 8px 0;
    }
    .m-input-wrapper {
        z-index: 0;
    }
    /deep/ .m-form-item-required .m-form-item-label:before{
        vertical-align: top;
    }
}
    .step-header {
        width: 200px;
        padding: 0 10px 0 30px;
        float: right;
        position: relative;
        overflow: hidden;
        margin-right: 12px;
        ul {
            padding: 0;
            width: 255px;
            float: left;
            position: relative;
            li {
                list-style-type: none;
                float: left;
                position: relative;
                width: 125px;
                &.active {
                    span {
                        background: #2d8cf0;
                    }
                    p {
                        color: #333333;
                    }
                }
                p {
                    font-weight: bold;
                    margin-top: 5px;
                    font-size: 13px;
                    color: #999999;
                    float: left;
                    position: relative;
                    left: -50%;
                    text-align: center;
                    width: 125px;
                }
                span {
                    position: relative;
                    height: 20px;
                    width: 20px;
                    border-radius: 10px;
                    background: #ccc;
                    left: -10px;
                    display: block;
                }
            }
        }
    }
    
    .step-bar {
        width: 125px;
        height: 13px;
        background: #ccc;
        position: absolute;
        border-radius: 12px;
        top: 4px;
        overflow: hidden;
    }
    
    .step-bar-active {
        width: 0px;
        height: 13px;
        background: #2d8cf0;
    }
    .step-container{
        width: 480px;
        margin: 0 auto;
        padding:10px 0;
    }
</style>
